<template>
  <div class="remove-padding-modal">
    <el-dialog :visible.sync="dialogVisible" width="1000px" top="5vh" @close="handleClose">
      <div class="grid-2-sesstion">
        <!-- Preview Left -->
        <div class="grid-left rm-scrollbar">
          <div class="header flex-center">
            <img
              :src="$utils('icons', 'ic_preview')"
              style="height: 18px; margin-top: -2px"
              class="mr-8"
            />
            <span class="header-text">{{ $t('happilyVillage.Preview_on_Mobile') }}</span>
          </div>
          <div class="body">
            <campaign-preview :form="form" :language="activeLanguageIndex" />
          </div>
        </div>

        <!-- Form Right -->
        <div class="grid-right rm-scrollbar">
          <form id="campaignModal" @submit.prevent="handleSubmit">
            <!-- Language Selection Tabs (show if languages are configured) -->
            <div v-if="companyLanguages && companyLanguages.length > 0" class="language-tabs-container">
              <div class="language-tabs-header">
                <span class="language-tabs-label">{{ $t('happilyVillage.campaign_form.content_language') }}</span>
              </div>
              <el-menu
                :default-active="activeLanguageIndex"
                class="language-menu"
                mode="horizontal"
                @select="handleLanguageSelect"
              >
                <el-menu-item
                  v-for="lang in companyLanguages"
                  :key="lang.code"
                  :index="lang.code"
                  class="language-menu-item"
                >
                  {{ lang.text }}
                  <span v-if="!isLanguageComplete(lang.code)" class="translation-incomplete-dot"></span>
                </el-menu-item>
              </el-menu>
            </div>
            
            <!-- Translation Mode Header -->
            <div v-if="isTranslationMode" class="translation-mode-header">
              <div class="translation-mode-info">
                <div class="translation-mode-title">{{ $t('happilyVillage.campaign_form.translation_mode_title') }}</div>
                <div class="translation-mode-hint">{{ $t('happilyVillage.campaign_form.translation_mode_hint') }}</div>
              </div>
              <button type="button" class="translation-copy-all-btn" @click="copyAllFromEnglish">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                {{ $t('happilyVillage.campaign_form.use_english_empty') }}
              </button>
            </div>

            <!-- Translation Validation Banner -->
            <div v-if="translationValidationMessage" class="translation-validation-banner">
              <svg class="translation-validation-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <div class="translation-validation-text">{{ translationValidationMessage }}</div>
              <button type="button" class="translation-validation-dismiss" @click="translationValidationMessage = ''">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div v-if="isStartedCampaignLocked" class="campaign-lock-banner">
              <div class="campaign-lock-banner-title">{{ $t('happilyVillage.campaign_form.live_lock_title') }}</div>
              <div class="campaign-lock-banner-text">
                {{ $t('happilyVillage.campaign_form.live_lock_body') }}
              </div>
            </div>

            <!-- Campaign Overview Section -->
            <div class="form-section campaign-overview-section">
              <div class="section-header">
                <div class="section-title">{{ isTranslationMode ? $t('happilyVillage.campaign_form.translatable_content') : $t('happilyVillage.campaign_form.campaign_overview') }}</div>
              </div>

<div class="overview-grid">
                <!-- Category - translatable -->
                <div class="overview-field">
                  <div class="field-label">{{ $t('happilyVillage.campaign_form.category') }}</div>
                  <el-input
                    :placeholder="isTranslationMode && form.campaignCategory.en ? form.campaignCategory.en : $t('happilyVillage.campaign_form.category_placeholder')"
                    v-model="form.campaignCategory[activeLanguageIndex]"
                    class="name"
                    :class="{ 'validate-input': (validation.campaignCategory && isPrimaryLanguage) || (validation.translationFields && isTranslationMode && form.campaignCategory.en && !form.campaignCategory[activeLanguageIndex]) }"
                  ></el-input>
                  <div v-if="validation.campaignCategory && isPrimaryLanguage" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.validation_category') }}</div>
                  </div>
                  <div v-if="validation.translationFields && isTranslationMode && form.campaignCategory.en && !form.campaignCategory[activeLanguageIndex]" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                  </div>
                  <div v-if="isTranslationMode && form.campaignCategory.en" class="translation-reference">
                    <span class="reference-text">{{ form.campaignCategory.en }}</span>
                    <button type="button" v-if="!form.campaignCategory[activeLanguageIndex]" class="use-english-btn" @click="copyFieldFromEnglish('campaignCategory')">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      {{ $t('happilyVillage.campaign_form.use_english') }}
                    </button>
                  </div>
                </div>

                <!-- Activity Type - non-translatable, only show in primary language -->
                <div v-if="isPrimaryLanguage" class="overview-field">
                  <div class="field-label">{{ $t('happilyVillage.campaign_form.activity_type') }}</div>
                  <el-cascader
                    v-model="form.inputType"
                    :options="inputTypeOptions"
                    :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"
                    :placeholder="$t('happilyVillage.campaign_form.activity_type_placeholder')"
                    style="width: 100%;"
                    class="input-style"
                    :disabled="isStartedCampaignLocked"
                  ></el-cascader>
                </div>

                <!-- Translatable fields - always show -->
                <div class="overview-field full-width">
                  <div class="field-label">{{ $t('happilyVillage.campaign_form.title') }}</div>
                  <el-input
                    :placeholder="isTranslationMode && form.title.en ? form.title.en : $t('happilyVillage.campaign_form.title_placeholder')"
                    v-model="form.title[activeLanguageIndex]"
                    class="name"
                    :class="{ 'validate-input': (validation.title && isPrimaryLanguage) || (validation.translationFields && isTranslationMode && form.title.en && !form.title[activeLanguageIndex]) }"
                  ></el-input>
                  <div v-if="validation.title && isPrimaryLanguage" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.validation_title') }}</div>
                  </div>
                  <div v-if="validation.translationFields && isTranslationMode && form.title.en && !form.title[activeLanguageIndex]" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                  </div>
                  <div v-if="isTranslationMode && form.title.en" class="translation-reference">
                    <span class="reference-text">{{ form.title.en }}</span>
                    <button type="button" v-if="!form.title[activeLanguageIndex]" class="use-english-btn" @click="copyFieldFromEnglish('title')">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      {{ $t('happilyVillage.campaign_form.use_english') }}
                    </button>
                  </div>
                </div>

                <div class="overview-field full-width">
                  <div class="field-label">{{ $t('happilyVillage.campaign_form.description') }}</div>
                  <el-input
                    type="textarea"
                    :placeholder="isTranslationMode && form.description.en ? form.description.en : $t('happilyVillage.campaign_form.description_placeholder')"
                    v-model="form.description[activeLanguageIndex]"
                    :rows="3"
                    class="description-input"
                    resize="none"
                  ></el-input>
                  <div v-if="isPrimaryLanguage" class="field-hint">{{ $t('happilyVillage.campaign_form.description_hint') }}</div>
                  <div v-if="validation.translationFields && isTranslationMode && form.description.en && !form.description[activeLanguageIndex]" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                  </div>
                  <div v-if="isTranslationMode && form.description.en" class="translation-reference">
                    <span class="reference-text">{{ form.description.en }}</span>
                    <button type="button" v-if="!form.description[activeLanguageIndex]" class="use-english-btn" @click="copyFieldFromEnglish('description')">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      {{ $t('happilyVillage.campaign_form.use_english') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Non-translatable sections - only show in primary language -->
            <div v-if="isPrimaryLanguage" class="form-section">
              <div class="title">{{ $t('happilyVillage.Icon') }} <span v-if="validation.iconKey" class="validate-worming-inline">{{ $t('happilyVillage.campaign_form.validation_icon') }}</span></div>
              <icon-picker v-model="form.iconKey" :class="{ 'validate-input-box': validation.iconKey }" />
            </div>

            <div v-if="isPrimaryLanguage" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.color_theme') }}</div>
              <theme-picker v-model="form.theme" />
            </div>

            <!-- Activity Type Settings (conditional) - non-translatable -->
            <div v-if="isPrimaryLanguage && (form.inputType === 'yes_no' || form.inputType === 'count')" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.activity_settings') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.locked_after_start') }}</div>
              
              <!-- Yes/No Success Answer Selection -->
              <div v-if="form.inputType === 'yes_no'">
                <div class="sub-title">{{ $t('happilyVillage.campaign_form.success_answer') }}</div>
                <el-radio-group
                  v-model="form.yesNoSuccessAnswer"
                  class="success-answer-group"
                  @change="handleYesNoSuccessChange"
                  :disabled="isStartedCampaignLocked"
                >
                  <el-radio label="yes">{{ $t('happilyVillage.campaign_form.yes_is_correct') }}</el-radio>
                  <el-radio label="no">{{ $t('happilyVillage.campaign_form.no_is_correct') }}</el-radio>
                </el-radio-group>
              </div>

              <!-- Count Input Settings -->
              <div v-if="form.inputType === 'count'">
                <div class="sub-title">{{ $t('happilyVillage.campaign_form.input_settings') }}</div>

                <el-checkbox
                  v-model="form.allowDecimals"
                  class="input-setting-checkbox"
                  style="margin-bottom: 12px;"
                  :disabled="isStartedCampaignLocked"
                >
                  <span class="checkbox-label">{{ $t('happilyVillage.campaign_form.allow_decimals') }}</span>
                  <div class="checkbox-hint">{{ $t('happilyVillage.campaign_form.allow_decimals_hint') }}</div>
                </el-checkbox>

                <div class="tracking-mode-group">
                  <div class="tracking-mode-label">{{ $t('happilyVillage.campaign_form.tracking_mode') }}</div>
                  <el-radio-group
                    v-model="form.trackingMode"
                    class="tracking-mode-radios"
                    :disabled="isStartedCampaignLocked"
                  >
                    <el-radio label="incremental">
                      <span class="radio-label">{{ $t('happilyVillage.campaign_form.incremental') }}</span>
                      <div class="radio-hint">{{ $t('happilyVillage.campaign_form.incremental_hint') }}</div>
                    </el-radio>
                    <el-radio label="cumulative">
                      <span class="radio-label">{{ $t('happilyVillage.campaign_form.cumulative') }}</span>
                      <div class="radio-hint">{{ $t('happilyVillage.campaign_form.cumulative_hint') }}</div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>

            <!-- Campaign Duration - non-translatable -->
            <div v-if="isPrimaryLanguage" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.campaign_duration') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.duration_locked') }}</div>
              <el-select
                v-model="form.timing.frequency"
                :placeholder="$t('happilyVillage.campaign_form.select_frequency')"
                class="input-style"
                style="width: 100%; margin-bottom: 14px;"
                :disabled="isStartedCampaignLocked"
              >
                <el-option :label="$t('happilyVillage.Daily')" value="daily"></el-option>
                <el-option :label="$t('happilyVillage.Weekly')" value="weekly"></el-option>
              </el-select>

              <div v-if="form.timing.frequency === 'weekly'" style="margin-bottom: 14px;">
                <div class="sub-title">{{ $t('happilyVillage.campaign_form.day_of_week') }}</div>
                <el-select
                  v-model="form.timing.dayOfWeek"
                  :placeholder="$t('happilyVillage.campaign_form.select_day')"
                  class="input-style"
                  style="width: 100%;"
                  :disabled="isStartedCampaignLocked"
                >
                  <el-option :label="$t('category.day_of_week.monday')" :value="1"></el-option>
                  <el-option :label="$t('category.day_of_week.tuesday')" :value="2"></el-option>
                  <el-option :label="$t('category.day_of_week.wednesday')" :value="3"></el-option>
                  <el-option :label="$t('category.day_of_week.thursday')" :value="4"></el-option>
                  <el-option :label="$t('category.day_of_week.friday')" :value="5"></el-option>
                  <el-option :label="$t('category.day_of_week.saturday')" :value="6"></el-option>
                  <el-option :label="$t('category.day_of_week.sunday')" :value="0"></el-option>
                </el-select>
              </div>

              <div class="grid-2" style="gap: 12px;">
                <div>
                  <div class="sub-title">{{ $t('happilyVillage.Start_Date') }}</div>
                  <el-date-picker
                    v-model="form.timing.startDate"
                    type="date"
                    :placeholder="$t('happilyVillage.campaign_form.select_start_date')"
                    style="width: 100%;"
                    :class="{ 'validate-input': validation.startDate }"
                    format="MMM dd, yyyy"
                    value-format="yyyy-MM-dd"
                    placement="bottom-start"
                    :append-to-body="false"
                    :disabled="isStartedCampaignLocked"
                  ></el-date-picker>
                  <div v-if="form.timing.startDate" class="date-display">
                    {{ formatStartDate(form.timing.startDate) }}
                  </div>
                </div>
                <div>
                  <div class="sub-title">{{ form.timing.frequency === 'daily' ? $t('happilyVillage.campaign_form.number_of_days') : $t('happilyVillage.campaign_form.number_of_weeks') }}</div>
                  <el-input-number
                    v-model="form.timing.occurrences"
                    :min="1"
                    :max="365"
                    :controls="false"
                    :placeholder="form.timing.frequency === 'daily' ? '30' : '4'"
                    style="width: 100%;"
                    :class="{ 'validate-input': validation.occurrences }"
                    :disabled="isStartedCampaignLocked"
                  ></el-input-number>
                  <div v-if="form.timing.startDate && form.timing.occurrences" class="date-display">
                    {{ $t('happilyVillage.campaign_form.ends') }} {{ formatEndDate() }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Goals section - Unit is translatable, rest is not -->
            <div v-if="showUnitField && isTranslationMode" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.unit_translation') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.locked_after_start') }}</div>
              <div class="overview-field full-width">
                <div class="field-label">{{ $t('happilyVillage.campaign_form.unit_of_measurement') }}</div>
                <el-input
                  v-model="form.goals.unit[activeLanguageIndex]"
                  :placeholder="form.goals.unit.en || $t('happilyVillage.campaign_form.unit_placeholder')"
                  class="name"
                  :disabled="isStartedCampaignLocked"
                ></el-input>
                <div v-if="validation.translationFields && form.goals.unit.en && !form.goals.unit[activeLanguageIndex]" class="validate-worming">
                  <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                </div>
                <div v-if="form.goals.unit.en" class="translation-reference">
                  <span class="reference-text">{{ form.goals.unit.en }}</span>
                  <button type="button" v-if="!isStartedCampaignLocked && !form.goals.unit[activeLanguageIndex]" class="use-english-btn" @click="copyFieldFromEnglish('unit')">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                    {{ $t('happilyVillage.campaign_form.use_english') }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Full Goals section - only in primary language -->
            <div v-if="isPrimaryLanguage" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.goals') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.goals_locked') }}</div>
              <div v-if="isInverseGoal()" class="field-hint" style="margin-top: 0; margin-bottom: 12px; color: #7D5ABA; background: #F3EBFF; padding: 8px 12px; border-radius: 8px;">
                📉 Lower is better: Participants succeed by staying below the target
              </div>
              
              <!-- Goal Unit - Only show for Count and Auto Sync types -->
              <div v-if="showUnitField" class="goal-unit-row">
                <div class="goal-unit-label">{{ $t('happilyVillage.campaign_form.unit_of_measurement') }}</div>
                <el-input
                  v-model="form.goals.unit[activeLanguageIndex]"
                  :placeholder="$t('happilyVillage.campaign_form.unit_placeholder')"
                  class="goal-unit-input"
                  size="small"
                  :disabled="isStartedCampaignLocked"
                ></el-input>
                <div class="goal-unit-hint">{{ $t('happilyVillage.campaign_form.unit_hint') }}</div>
              </div>
              
              <!-- Goal type explanation for types without units -->
              <div v-if="!showUnitField" class="goal-type-hint">
                <span v-if="form.inputType === 'quiz'">📝 Goals are measured in <strong>correct answers</strong></span>
                <span v-else-if="form.inputType === 'multiple_selection'">☑️ Goals are measured in <strong>items completed</strong></span>
                <span v-else-if="form.inputType === 'yes_no'">✓ Goals are measured in <strong>successful {{ form.timing.frequency === 'weekly' ? 'weeks' : 'days' }}</strong></span>
              </div>
              
              <!-- Daily Goal (Required) - Hidden for Yes/No type -->
              <div class="goal-row" v-if="showDailyGoalInput">
                <div class="goal-label-required">
                  <span v-if="isInverseGoal()">{{ periodLabel }} {{ $t('happilyVillage.campaign_form.limit') }}</span>
                  <span v-else>{{ periodLabel }} {{ $t('happilyVillage.Goal') }}</span>
                  <span class="required-badge">{{ $t('happilyVillage.campaign_form.required') }}</span>
                </div>
                <div class="goal-input-with-unit">
                  <el-input-number
                    v-model="form.goals.dailyTarget"
                    :min="1"
                    :controls="false"
                    class="goal-input"
                    :placeholder="isInverseGoal() ? $t('happilyVillage.campaign_form.max_allowed') : $t('happilyVillage.campaign_form.target')"
                    :disabled="isStartedCampaignLocked"
                  ></el-input-number>
                  <span v-if="showUnitField" class="goal-unit-label">{{ getDisplayUnitText() }}</span>
                  <span v-else class="goal-unit-label-text">{{ getGoalUnitText() }}</span>
                </div>
              </div>
              
              
              <!-- Yes/No Daily Goal Explanation (binary success) -->
              <div class="goal-row yes-no-explanation" v-if="form.inputType === 'yes_no'">
                <div class="yes-no-daily-info">
                  <span class="yes-no-icon">✓</span>
                  <div class="yes-no-text">
                    <div class="yes-no-title">{{ periodLabel }} {{ $t('happilyVillage.Goal') }}</div>
                    <div class="yes-no-description">{{ form.timing.frequency === 'weekly' ? $t('happilyVillage.campaign_form.yesno_desc_weekly') : $t('happilyVillage.campaign_form.yesno_desc_daily') }}</div>
                  </div>
                </div>
              </div>
              
              <!-- Individual Overall Goal (Required) -->
              <div class="goal-row">
                <div class="goal-label-required">
                  <span v-if="isInverseGoal()">{{ $t('happilyVillage.campaign_form.individual_overall_limit') }}</span>
                  <span v-else>{{ $t('happilyVillage.campaign_form.individual_overall_goal') }}</span>
                  <span class="required-badge">{{ $t('happilyVillage.campaign_form.required') }}</span>
                </div>
                <div class="goal-input-container">
                  <div class="goal-input-with-unit">
                    <el-input-number
                      v-model="form.goals.individualTarget"
                      :min="1"
                      :controls="false"
                      class="goal-input"
                      :placeholder="isInverseGoal() ? $t('happilyVillage.campaign_form.max_total') : $t('happilyVillage.campaign_form.target_total')"
                      :disabled="isStartedCampaignLocked"
                    ></el-input-number>
                    <span v-if="showUnitField" class="goal-unit-label">{{ getDisplayUnitText() }}</span>
                    <span v-else class="goal-unit-label-text">{{ getGoalUnitText() }}</span>
                  </div>
                  <div class="goal-hint">{{ $t('happilyVillage.campaign_form.recommended') }}: {{ getRecommendedIndividualTarget }} ({{ periodLabel }} × {{ form.timing.frequency === 'weekly' ? $t('happilyVillage.campaign_form.weeks') : $t('happilyVillage.campaign_form.days') }} × 80%)</div>
                </div>
              </div>
              
              <!-- Group Overall Goal (Optional) -->
              <div class="goal-row">
                <el-checkbox
                  v-model="form.goals.groupEnabled"
                  class="goal-checkbox"
                  :disabled="isStartedCampaignLocked"
                >
                  <span v-if="isInverseGoal()">{{ $t('happilyVillage.campaign_form.group_overall_limit') }}</span>
                  <span v-else>{{ $t('happilyVillage.campaign_form.group_overall_goal') }}</span>
                  <span class="optional-badge">{{ $t('happilyVillage.campaign_form.optional') }}</span>
                </el-checkbox>
                <div v-if="form.goals.groupEnabled" class="goal-input-with-unit">
                  <el-input-number
                    v-model="form.goals.groupTarget"
                    :min="1"
                    :controls="false"
                    class="goal-input"
                    :placeholder="isInverseGoal() ? $t('happilyVillage.campaign_form.max_combined') : $t('happilyVillage.campaign_form.target_combined')"
                    :disabled="isStartedCampaignLocked"
                  ></el-input-number>
                  <span v-if="showUnitField" class="goal-unit-label">{{ getDisplayUnitText() }}</span>
                  <span v-else class="goal-unit-label-text">{{ getGoalUnitText() }}</span>
                </div>
              </div>
            </div>

            <!-- Reward section - non-translatable -->
            <div v-if="isPrimaryLanguage" class="form-section">
              <div class="title">{{ $t('happilyVillage.Reward') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.reward_locked') }}</div>
              
              <!-- Multiple Selection Reward Condition - Show First -->
              <div v-if="form.inputType === 'multiple_selection'" class="reward-condition" style="margin-bottom: 20px;">
                <el-radio-group
                  v-model="form.reward.multipleSelectionRule"
                  class="reward-condition-group"
                  :disabled="isStartedCampaignLocked"
                >
                  <el-radio label="per_item">{{ $t('happilyVillage.campaign_form.earn_per_item') }}</el-radio>
                  <el-radio label="daily_goal">{{ $t('happilyVillage.campaign_form.earn_on_daily_goal') }}</el-radio>
                </el-radio-group>
              </div>
              
              <el-radio-group
                v-model="form.reward.type"
                class="reward-group"
                :disabled="isStartedCampaignLocked"
              >
                <div class="reward-option">
                  <div class="reward-option-content">
                    <el-radio label="instant">
                      <span class="reward-label">{{ $t('happilyVillage.Instant_Coins') }}</span>
                    </el-radio>
                    <div class="reward-description">{{ getRewardDescription('instant') }}</div>
                  </div>
                  <div v-if="form.reward.type === 'instant'" class="reward-input-with-label">
                    <el-input-number
                      v-model="form.reward.coins"
                      :min="0"
                      :controls="false"
                      class="reward-input"
                      :disabled="isStartedCampaignLocked"
                    ></el-input-number>
                    <span class="reward-coin-label">coins</span>
                  </div>
                </div>
                <div class="reward-option">
                  <div class="reward-option-content">
                    <el-radio label="charged">
                      <span class="reward-label">{{ $t('happilyVillage.campaign_form.charged_coins') }}</span>
                    </el-radio>
                    <div class="reward-description">{{ getRewardDescription('charged') }}</div>
                  </div>
                  <div v-if="form.reward.type === 'charged'" class="reward-input-with-label">
                    <el-input-number
                      v-model="form.reward.chargedCoins"
                      :min="0"
                      :controls="false"
                      class="reward-input"
                      :disabled="isStartedCampaignLocked"
                    ></el-input-number>
                    <span class="reward-coin-label">coins</span>
                  </div>
                </div>
                <div class="reward-option">
                  <div class="reward-option-content">
                    <el-radio label="prize_pool">
                      <span class="reward-label">{{ $t('happilyVillage.campaign_form.prize_pool') }}</span>
                    </el-radio>
                    <div class="reward-description">{{ $t('happilyVillage.campaign_form.prize_pool_description') }}</div>
                  </div>
                  <div v-if="form.reward.type === 'prize_pool'" class="reward-input-with-label">
                    <el-input-number
                      v-model="form.reward.prizePoolCoins"
                      :min="0"
                      :controls="false"
                      class="reward-input"
                      :disabled="isStartedCampaignLocked"
                    ></el-input-number>
                    <span class="reward-coin-label">coins</span>
                  </div>
                </div>
              </el-radio-group>
            </div>

            <!-- Access & Participation (Audience, Entry Cost, etc.) - non-translatable -->
            <div v-if="isPrimaryLanguage" class="form-section access-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.access_participation') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.access_locked') }}</div>
              
              <!-- Row 1: Audience & Comment Permissions -->
              <div class="access-grid">
                <div class="access-field">
                  <div class="sub-title">{{ $t('happilyVillage.campaign_form.audience') }}</div>
                  <el-cascader
                    class="defaulttags audience-cascader"
                    v-model="huddleTag"
                    :placeholder="$t('happilyVillage.Team_or_Name')"
                    :options="huddleTagData"
                    :props="{ multiple: true }"
                    style="width: 100%"
                    :collapse-tags="huddleTag ? huddleTag.length > 3 : false"
                    :debounce="500"
                    filterable
                    :class="[ blurMode ? 'blurelement': '' ]"
                    :disabled="isStartedCampaignLocked"
                  ></el-cascader>
                  <div v-if="isProgramOnlySelected" class="program-only-hint">
                    <i class="el-icon-lock"/>
                    <span>
                      Program-only campaigns are hidden from University and only surface to people enrolled in a Learning Program that uses them. This is a visibility scope, not an encryption boundary.
                    </span>
                  </div>
                  <div class="field-hint">{{ getAudienceHint() }}</div>
                </div>
                
                <div class="access-field">
                  <div class="sub-title">{{ $t('happilyVillage.Comment_Permissions') }}</div>
                  <el-select
                    v-model="form.commentPermission"
                    :placeholder="$t('happilyVillage.campaign_form.select_commenter')"
                    class="input-style"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in commentPermOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="field-hint">{{ $t('happilyVillage.campaign_form.who_can_comment') }}</div>
                </div>
              </div>
              
              <!-- Row 2: Entry Cost & Limit -->
              <div class="access-grid" style="margin-top: 16px;">
                <div class="access-field">
                  <div class="sub-title">{{ $t('happilyVillage.Entry_Cost') }}</div>
                  <el-input-number
                    v-model="form.entryCost"
                    :min="0"
                    :controls="false"
                    placeholder="0"
                    style="width: 100%;"
                    :disabled="isStartedCampaignLocked"
                  ></el-input-number>
                  <div class="field-hint">{{ $t('happilyVillage.campaign_form.coins_to_join') }}</div>
                </div>

                <div class="access-field">
                  <div class="sub-title">{{ $t('happilyVillage.campaign_form.entry_limit') }}</div>
                  <el-input-number
                    v-model="form.entryLimit"
                    :min="1"
                    :controls="false"
                    :disabled="!form.entryLimitEnabled || isStartedCampaignLocked"
                    :placeholder="$t('happilyVillage.campaign_form.no_limit')"
                    style="width: 100%;"
                  ></el-input-number>
                  <el-checkbox
                    v-model="form.entryLimitEnabled"
                    class="entry-limit-checkbox"
                    :disabled="isStartedCampaignLocked"
                  >
                    {{ $t('happilyVillage.campaign_form.set_participant_limit') }}
                  </el-checkbox>
                </div>
              </div>
            </div>

            <!-- Multiple Selection Items Section - Translatable -->
            <div v-if="form.inputType === 'multiple_selection'" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.checklist_items') }}</div>
              <div v-if="isPrimaryLanguage" class="field-hint" style="margin-top: 0; margin-bottom: 16px;">
                {{ $t('happilyVillage.campaign_form.add_checklist_hint') }}
              </div>
              <div v-else class="field-hint" style="margin-top: 0; margin-bottom: 16px;">
                {{ $t('happilyVillage.campaign_form.translate_checklist_hint') }}
              </div>

              <div class="checklist-items-list" v-if="form.checklistItems && form.checklistItems.length > 0">
                <div
                  v-for="(item, index) in form.checklistItems"
                  :key="index"
                  class="checklist-item-row"
                >
                  <div class="checklist-item-number">{{ index + 1 }}</div>
                  <div class="checklist-item-input-wrapper">
                    <el-input
                      v-model="form.checklistItems[index][activeLanguageIndex]"
                      :placeholder="isTranslationMode && form.checklistItems[index].en ? form.checklistItems[index].en : $t('happilyVillage.campaign_form.enter_checklist_item')"
                      class="checklist-item-input"
                      :disabled="isStartedCampaignLocked"
                    ></el-input>
                    <div v-if="validation.translationFields && isTranslationMode && form.checklistItems[index].en && !form.checklistItems[index][activeLanguageIndex]" class="validate-worming" style="margin-top: 2px;">
                      <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                    </div>
                    <div v-if="isTranslationMode && form.checklistItems[index].en" class="translation-reference-inline">
                      <span class="reference-text">{{ form.checklistItems[index].en }}</span>
                      <button type="button" v-if="!isStartedCampaignLocked && !form.checklistItems[index][activeLanguageIndex]" class="use-english-btn use-english-btn--inline" @click="copyChecklistItemFromEnglish(index)">{{ $t('happilyVillage.campaign_form.use_english') }}</button>
                    </div>
                  </div>
                  <el-button
                    v-if="isPrimaryLanguage && !isStartedCampaignLocked"
                    type="text"
                    size="small"
                    @click="removeChecklistItem(index)"
                    style="color: #F56C6C;"
                    icon="el-icon-delete"
                  >
                  </el-button>
                </div>
              </div>

              <el-button
                v-if="isPrimaryLanguage && !isStartedCampaignLocked"
                class="btn-add-question"
                @click="addChecklistItem"
                icon="el-icon-plus"
              >
                {{ form.checklistItems && form.checklistItems.length > 0 ? $t('happilyVillage.campaign_form.add_another_item') : $t('happilyVillage.campaign_form.add_first_item') }}
              </el-button>
              <div v-if="isTranslationMode && (!form.checklistItems || form.checklistItems.length === 0)" class="translation-empty-state">
                {{ $t('happilyVillage.campaign_form.no_checklist_to_translate') }}
              </div>
            </div>

            <!-- Quiz Questions Section - Translatable -->
            <div v-if="form.inputType === 'quiz'" class="form-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.quiz_questions') }}</div>
              <div v-if="isPrimaryLanguage" class="field-hint" style="margin-top: 0; margin-bottom: 16px;">
                Add {{ form.timing.occurrences || 30 }} question{{ (form.timing.occurrences || 30) > 1 ? 's' : '' }} (one per {{ form.timing.frequency === 'daily' ? 'day' : 'week' }})
              </div>
              <div v-else class="field-hint" style="margin-top: 0; margin-bottom: 16px;">
                {{ $t('happilyVillage.campaign_form.translate_quiz_hint') }}
              </div>
              
              <div class="quiz-questions-list" v-if="form.quizQuestions && form.quizQuestions.length > 0">
                <div 
                  v-for="(question, index) in form.quizQuestions" 
                  :key="index"
                  class="quiz-question-item"
                >
                  <div class="quiz-question-header">
                    <span class="quiz-question-number">{{ $t('happilyVillage.campaign_form.question') }} {{ index + 1 }}</span>
                    <el-button
                      v-if="isPrimaryLanguage && !isStartedCampaignLocked"
                      type="text"
                      size="small"
                      @click="removeQuizQuestion(index)"
                      style="color: #F56C6C;"
                    >
                      {{ $t('happilyVillage.campaign_form.remove') }}
                    </el-button>
                  </div>
                  
                  <el-input
                    v-model="question.question[activeLanguageIndex]"
                    :placeholder="isTranslationMode && question.question.en ? question.question.en : $t('happilyVillage.campaign_form.enter_question')"
                    class="quiz-question-input"
                    :disabled="isStartedCampaignLocked"
                  ></el-input>
                  <div v-if="validation.translationFields && isTranslationMode && question.question.en && !question.question[activeLanguageIndex]" class="validate-worming">
                    <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                  </div>
                  <div v-if="isTranslationMode && question.question.en" class="translation-reference">
                    <span class="reference-text">{{ question.question.en }}</span>
                    <button type="button" v-if="!isStartedCampaignLocked && !question.question[activeLanguageIndex]" class="use-english-btn" @click="copyQuizQuestionFromEnglish(index)">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      {{ $t('happilyVillage.campaign_form.use_english') }}
                    </button>
                  </div>
                  
                  <div class="quiz-options">
                    <div 
                      v-for="(option, optIndex) in getQuizOptionsForLanguage(question)"
                      :key="optIndex"
                      class="quiz-option-row"
                    >
                      <el-radio
                        v-model="question.correctAnswer"
                        :label="optIndex"
                        class="quiz-option-radio"
                        :disabled="isTranslationMode || isStartedCampaignLocked"
                      >
                        <div class="quiz-option-input-wrapper">
                          <el-input
                            v-model="question.options[activeLanguageIndex][optIndex]"
                            :placeholder="isTranslationMode && question.options.en && question.options.en[optIndex] ? question.options.en[optIndex] : `Option ${optIndex + 1}`"
                            size="small"
                            :disabled="isStartedCampaignLocked"
                          ></el-input>
                          <div v-if="validation.translationFields && isTranslationMode && question.options.en && question.options.en[optIndex] && (!question.options[activeLanguageIndex] || !question.options[activeLanguageIndex][optIndex])" class="validate-worming" style="margin-top: 2px;">
                            <div class="text">{{ $t('happilyVillage.campaign_form.translation_required') }}</div>
                          </div>
                          <div v-if="isTranslationMode && question.options.en && question.options.en[optIndex]" class="translation-reference-inline">
                            <span class="reference-text">{{ question.options.en[optIndex] }}</span>
                            <button type="button" v-if="!isStartedCampaignLocked && (!question.options[activeLanguageIndex] || !question.options[activeLanguageIndex][optIndex])" class="use-english-btn use-english-btn--inline" @click="copyQuizOptionFromEnglish(index, optIndex)">{{ $t('happilyVillage.campaign_form.use_english') }}</button>
                          </div>
                        </div>
                      </el-radio>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isTranslationMode && (!form.quizQuestions || form.quizQuestions.length === 0)" class="translation-empty-state">
                {{ $t('happilyVillage.campaign_form.no_quiz_to_translate') }}
              </div>
              
              <el-button
                v-if="isPrimaryLanguage && !isStartedCampaignLocked && (!form.quizQuestions || form.quizQuestions.length < (form.timing.occurrences || 30))"
                class="btn-add-question"
                @click="addQuizQuestion"
                icon="el-icon-plus"
              >
                {{ form.quizQuestions && form.quizQuestions.length > 0 ? $t('happilyVillage.campaign_form.add_question') : $t('happilyVillage.campaign_form.add_first_question') }}
              </el-button>
            </div>

            <!-- Launch - placed near the submit button so the launch decision and the CTA are read together -->
            <div v-if="isPrimaryLanguage" class="form-section launch-section">
              <div class="title">{{ $t('happilyVillage.campaign_form.launch') }}</div>
              <div v-if="isStartedCampaignLocked" class="field-hint">{{ $t('happilyVillage.campaign_form.launch_locked') }}</div>

              <div class="launch-mode-cards" role="radiogroup" :aria-label="$t('happilyVillage.campaign_form.launch')">
                <button
                  type="button"
                  class="launch-card"
                  :class="{ active: launchMode === 'now' }"
                  role="radio"
                  :aria-checked="launchMode === 'now'"
                  :disabled="isStartedCampaignLocked"
                  @click="setLaunchMode('now')"
                >
                  <span class="launch-card-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                  </span>
                  <span class="launch-card-body">
                    <span class="launch-card-title">{{ $t('happilyVillage.campaign_form.launch_now') }}</span>
                    <span class="launch-card-sub">{{ $t('happilyVillage.campaign_form.launch_now_sub') }}</span>
                  </span>
                </button>
                <button
                  type="button"
                  class="launch-card"
                  :class="{ active: launchMode === 'scheduled' }"
                  role="radio"
                  :aria-checked="launchMode === 'scheduled'"
                  :disabled="isStartedCampaignLocked"
                  @click="setLaunchMode('scheduled')"
                >
                  <span class="launch-card-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/></svg>
                  </span>
                  <span class="launch-card-body">
                    <span class="launch-card-title">{{ $t('happilyVillage.campaign_form.schedule_later') }}</span>
                    <span class="launch-card-sub">{{ $t('happilyVillage.campaign_form.schedule_later_sub') }}</span>
                  </span>
                </button>
              </div>

              <transition name="launch-reveal">
                <div v-if="launchMode === 'scheduled'" class="launch-schedule-block">
                  <div class="sub-title">{{ $t('happilyVillage.campaign_form.launch_datetime') }}</div>
                  <el-date-picker
                    v-model="form.launchAt"
                    type="datetime"
                    format="MMM dd, yyyy h:mm A"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="launchDatePickerOptions"
                    :placeholder="$t('happilyVillage.campaign_form.pick_datetime')"
                    style="width: 100%;"
                    :class="{ 'validate-input': validation.launchAt || validation.launchAtInPast }"
                    placement="bottom-start"
                    :append-to-body="false"
                    :disabled="isStartedCampaignLocked"
                  ></el-date-picker>
                  <div v-if="form.launchAt && !validation.launchAtInPast" class="launch-preview">
                    <svg class="launch-preview-icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/>
                    </svg>
                    <span>{{ launchPreviewSentence }}</span>
                  </div>
                  <div v-if="validation.launchAt" class="validate-worming validate-warning--soft">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <span>{{ $t('happilyVillage.campaign_form.pick_datetime') }}</span>
                  </div>
                  <div v-if="validation.launchAtInPast" class="validate-worming validate-warning--soft">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <span>{{ $t('happilyVillage.campaign_form.scheduled_must_be_future') }}</span>
                  </div>
                </div>
              </transition>
            </div>

            <div class="form-actions">
              <el-button
                class="btn-add bigger cta-with-icon"
                native-type="submit"
                :loading="isSubmitLocked"
                :disabled="isSubmitLocked"
              >
                <span class="cta-icon" aria-hidden="true">
                  <svg v-if="launchMode === 'now'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                  </svg>
                  <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/>
                  </svg>
                </span>
                <span class="cta-label">{{ ctaLabel }}</span>
              </el-button>
            </div>
          </form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// Default presets for each campaign type
// These provide sensible starting values to make campaign creation easier
const CAMPAIGN_TYPE_DEFAULTS = {
  quiz: {
    dailyTarget: 1,           // 1 correct answer per period
    unit: 'correct',
    title: { daily: "Daily Knowledge Challenge", weekly: "Weekly Knowledge Challenge" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  count: {
    dailyTarget: 10,          // Generic count goal
    unit: 'items',
    title: { daily: "Today's activity count", weekly: "This week's activity count" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  auto_sync_steps: {
    dailyTarget: 8000,        // 8,000 steps per day (or per week for weekly)
    weeklyTarget: 50000,      // ~7,000 steps/day average for weekly
    unit: 'steps',
    title: { daily: "Yesterday's step count", weekly: "This week's step count" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  auto_sync_sleep: {
    dailyTarget: 7,           // 7 hours of sleep
    weeklyTarget: 49,         // 7 hours × 7 days for weekly
    unit: 'hours',
    title: { daily: "Last night's sleep", weekly: "This week's sleep total" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  auto_sync_screen: {
    dailyTarget: 2,           // Max 2 hours screen time (inverse goal)
    weeklyTarget: 14,         // Max 14 hours for weekly
    unit: 'hours',
    title: { daily: "Yesterday's screen time", weekly: "This week's screen time" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  auto_sync_exercise: {
    dailyTarget: 30,          // 30 minutes exercise
    weeklyTarget: 150,        // 150 minutes per week (WHO recommendation)
    unit: 'minutes',
    title: { daily: "Yesterday's exercise", weekly: "This week's exercise total" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  auto_sync_distance: {
    dailyTarget: 5,           // 5 km distance
    weeklyTarget: 25,         // 25 km per week
    unit: 'km',
    title: { daily: "Yesterday's distance", weekly: "This week's distance total" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
  multiple_selection: {
    dailyTarget: 4,           // Default to 4 items (will be overridden by actual checklist count)
    unit: 'items',
    title: { daily: "Complete your daily checklist", weekly: "Complete your weekly checklist" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1, multipleSelectionRule: 'per_item' },
  },
  yes_no: {
    dailyTarget: 1,           // Binary: 1 successful response per period
    unit: '✓',                // Checkmark default, but admin can customize
    title: { daily: "Did you complete today's goal?", weekly: "Did you complete this week's goal?" },
    reward: { type: 'charged', coins: 1, chargedCoins: 1, prizePoolCoins: 1 },
  },
};

// Default occurrences for each frequency
const DEFAULT_OCCURRENCES = {
  daily: 30,   // 30 days (~6 weeks)
  weekly: 8,   // 8 weeks (~2 months)
};

export default {
  name: "university-campaign-form",
  components: {
    campaignPreview: require("./components/CampaignPreview").default,
    iconPicker: require("./components/IconPicker").default,
    themePicker: require("./components/ThemePicker").default,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: null,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isInitializingForm: false, // Flag to prevent applying defaults during edit form load
      localSubmitLocked: false,
      activeLanguageIndex: 'en', // Currently selected language for translation input
      launchMode: 'now', // 'now' | 'scheduled' — drives the Launch UI and submit-time stamping
      launchDatePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          const startOfToday = new Date();
          startOfToday.setHours(0, 0, 0, 0);
          return time.getTime() < startOfToday.getTime();
        },
        shortcuts: [
          {
            text: 'Tomorrow, 9:00 AM',
            onClick(picker) {
              const d = new Date();
              d.setDate(d.getDate() + 1);
              d.setHours(9, 0, 0, 0);
              picker.$emit('pick', d);
            },
          },
          {
            text: 'Next Monday, 9:00 AM',
            onClick(picker) {
              const d = new Date();
              const daysUntilMonday = (1 - d.getDay() + 7) % 7 || 7;
              d.setDate(d.getDate() + daysUntilMonday);
              d.setHours(9, 0, 0, 0);
              picker.$emit('pick', d);
            },
          },
          {
            text: 'In 1 hour',
            onClick(picker) {
              const d = new Date();
              d.setMinutes(0, 0, 0);
              d.setHours(d.getHours() + 1);
              picker.$emit('pick', d);
            },
          },
        ],
      },
      form: {
        // Multilingual fields - objects keyed by language code
        campaignCategory: { en: "" },
        description: { en: "" },
        title: { en: "" },
        iconKey: null,
        theme: { gradientKey: "purple", accentHex: "#7D5ABA" },
        inputType: "count",
        inputSubType: null, // For auto_sync subtypes
        yesNoSuccessAnswer: "yes", // For yes_no type: which answer is correct
        yesNoOptions: { 
          yes: { en: "Yes, I did!", th: "ใช่ ทำแล้ว!" },
          no: { en: "No", th: "ไม่" }
        }, // Multilingual display options for yes_no type
        allowDecimals: false, // For count type: allow decimal values
        trackingMode: "incremental", // For count type: incremental or cumulative
        launchAt: null, // null = launch immediately on save; ISO-ish string = scheduled launch
        timing: {
          frequency: "daily",
          startDate: null,
          occurrences: 30,
          dayOfWeek: 1, // Monday by default
        },
        goals: {
          dailyEnabled: true,       // Always required
          dailyTarget: 10,
          individualEnabled: true,  // Always required
          individualTarget: 240,    // Auto-calculated: 10 × 30 × 0.8
          groupEnabled: false,      // Optional
          groupTarget: 1000,
          unit: { en: "items" }, // Multilingual unit label for all goals
        },
        reward: {
          type: "charged",
          coins: 1,
          chargedCoins: 1,
          prizePoolCoins: 1,
          multipleSelectionRule: "per_item", // per_item or daily_goal
        },
        entryCost: 5,
        entryLimit: 100, // Max number of participants
        entryLimitEnabled: false, // Whether to enforce participant limit
        commentPermission: 1, // 1 = Anyone, 2 = Only participants, 3 = Only creator
        quizQuestions: [], // Array of quiz questions with multilingual question/options
        checklistItems: [], // Array of multilingual checklist items for multiple_selection
      },
      // Audience data - using same pattern as Town Hall and University Sessions
      // Array of arrays for el-cascader with multiple: true (e.g., [["everyone"]] or [["-Lxxx"], ["-Lyyy"]])
      huddleTag: [["everyone"]],
      translationValidationMessage: '',
      validation: {
        campaignCategory: false,
        title: false,
        startDate: false,
        launchAt: false,
        launchAtInPast: false,
        occurrences: false,
        iconKey: false,
        translationFields: false,
      },
      commentPermOptions: [
        { value: 1, label: "Anyone can comment" },
        { value: 2, label: "Only participants can comment" },
        { value: 3, label: "Only me" },
      ],
      inputTypeOptions: [
        {
          value: "quiz",
          label: "Quiz",
        },
        {
          value: "count",
          label: "Count",
        },
        {
          value: "auto_sync",
          label: "Auto Sync",
          children: [
            { value: "auto_sync_steps", label: "Steps" },
            { value: "auto_sync_sleep", label: "Sleep Time" },
            // TODO: Uncomment when mobile app supports this API integration
            // { value: "auto_sync_screen", label: "Screen Time" },
            { value: "auto_sync_exercise", label: "Exercise Minutes" },
            { value: "auto_sync_distance", label: "Distance" },
          ],
        },
        {
          value: "multiple_selection",
          label: "Multiple Selection",
        },
        {
          value: "yes_no",
          label: "Yes/No",
        },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
    },
    isEdit() {
      return this.campaign && this.campaign.id;
    },
    isStartedCampaignLocked() {
      if (!this.isEdit || !this.campaign || !this.campaign.timing || !this.campaign.timing.startDate) {
        return false;
      }
      const startDate = this.parseCampaignDate(this.campaign.timing.startDate);
      return !!startDate && new Date() >= startDate;
    },
    getRecommendedIndividualTarget() {
      const dailyTarget = this.form.goals.dailyTarget || 10;
      const occurrences = this.form.timing.occurrences || 30;
      return Math.round(dailyTarget * occurrences * 0.8);
    },
    showUnitField() {
      // Show unit field for Count, Auto Sync, and Yes/No types
      // Quiz and Multiple Selection have fixed units
      const typesWithUnits = ['count', 'auto_sync_steps', 'auto_sync_sleep', 'auto_sync_screen', 'auto_sync_exercise', 'auto_sync_distance', 'yes_no'];
      return typesWithUnits.includes(this.form.inputType);
    },
    showDailyGoalInput() {
      if (this.form.inputType === 'yes_no') return false;
      return true;
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    companyHolidays() {
      // Get company holidays from settings store
      const settings = this.$store.getters['settings/setting'];
      return settings && settings.holiday_val ? settings.holiday_val : [];
    },
    periodLabel() {
      return this.form.timing.frequency === 'weekly' ? 'Weekly' : 'Daily';
    },
    companyLanguages() {
      // Get available languages from store (same as Questions module)
      const languages = this.$store.getters["reward/language"];
      // Always ensure at least English is available
      if (!languages || languages.length === 0) {
        return [{ code: 'en', text: 'English' }];
      }
      return languages;
    },
    hasMultipleLanguages() {
      return this.companyLanguages.length > 1;
    },
    isPrimaryLanguage() {
      // Primary language is English - show full form
      return this.activeLanguageIndex === 'en';
    },
    isTranslationMode() {
      // True when editing translations (non-English language selected)
      return this.activeLanguageIndex !== 'en';
    },
    activeLanguageName() {
      // Get the display name of the currently selected language
      const lang = this.companyLanguages.find(l => l.code === this.activeLanguageIndex);
      return lang ? lang.text : this.activeLanguageIndex.toUpperCase();
    },
    huddleTagData() {
      // Get huddle/team data from store (same as university sessions)
      return this.$store.getters["happilyvillageUniversity/huddleTagData"] || [];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    isProgramOnlySelected() {
      const tags = this.huddleTag || [];
      for (const tag of tags) {
        if (Array.isArray(tag) ? tag.indexOf('program_only') !== -1 : tag === 'program_only') {
          return true;
        }
      }
      return false;
    },
    isSubmitLocked() {
      return this.submitting || this.localSubmitLocked;
    },
    launchPreviewSentence() {
      if (!this.form.launchAt) return '';
      const d = new Date(this.form.launchAt);
      if (isNaN(d.getTime())) return '';
      const weekday = d.toLocaleDateString('en-US', { weekday: 'long' });
      const datePart = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
      const timePart = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      const startOfTarget = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      const diffDays = Math.round((startOfTarget - startOfToday.getTime()) / (1000 * 60 * 60 * 24));
      let relative = '';
      if (diffDays <= 0) relative = 'today';
      else if (diffDays === 1) relative = 'tomorrow';
      else relative = `in ${diffDays} days`;
      return `Sign-ups will open ${weekday}, ${datePart} at ${timePart} — ${relative}.`;
    },
    ctaLabel() {
      if (this.isEdit) return this.$t('happilyVillage.campaign_form.update_campaign');
      if (this.launchMode === 'now') return this.$t('happilyVillage.campaign_form.launch_campaign');
      if (!this.form.launchAt) return this.$t('happilyVillage.campaign_form.schedule_campaign');
      const d = new Date(this.form.launchAt);
      if (isNaN(d.getTime())) return this.$t('happilyVillage.campaign_form.schedule_campaign');
      const datePart = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      const timePart = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      return `Schedule for ${datePart}, ${timePart}`;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      } else {
        this.localSubmitLocked = false;
      }
    },
    submitting(val) {
      if (!val) {
        this.localSubmitLocked = false;
      }
    },
    campaign: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.initForm();
        }
      },
      immediate: true,
      deep: true
    },
    'form.goals.dailyTarget'() {
      this.calculateIndividualTarget();
    },
    'form.timing.occurrences'() {
      this.calculateIndividualTarget();
    },
    'form.inputType'(newType, oldType) {
      // Apply defaults for the new campaign type
      this.applyTypeDefaults(newType, oldType);
    },
    'form.reward.multipleSelectionRule'(newRule) {
      if (this.form.inputType === 'multiple_selection') {
        const itemCount = (this.form.checklistItems && this.form.checklistItems.length) ? this.form.checklistItems.length : 1;
        this.form.goals.dailyTarget = itemCount;
        this.calculateIndividualTarget(true);
      }
    },
    'form.checklistItems': {
      handler(newItems) {
        if (this.form.inputType === 'multiple_selection') {
          const maxItems = (newItems && newItems.length) ? newItems.length : 1;
          if (this.form.goals.dailyTarget > maxItems) {
            this.form.goals.dailyTarget = maxItems;
            this.calculateIndividualTarget(true);
          }
        }
      },
      deep: true
    },
    'form.timing.frequency'(newFrequency, oldFrequency) {
      // Skip during form initialization
      if (this.isInitializingForm) return;
      
      // Handle frequency change
      this.applyFrequencyDefaults(newFrequency, oldFrequency);
    },
    companyLanguages: {
      handler(languages) {
        // Initialize multilingual fields for each language when languages change
        if (languages && languages.length > 0) {
          this.initializeMultilingualFields();
        }
      },
      immediate: true
    },
  },
  methods: {
    parseCampaignDate(dateValue) {
      if (!dateValue) return null;
      if (dateValue.toDate) return dateValue.toDate();
      if (dateValue instanceof Date) return dateValue;
      const parsed = new Date(dateValue);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    handleLanguageSelect(langCode) {
      this.activeLanguageIndex = langCode;
    },
    isLanguageComplete(langCode) {
      if (langCode === 'en') return true;
      if (this.form.title && typeof this.form.title === 'object') {
        if (this.form.title.en && this.form.title.en.trim() && (!this.form.title[langCode] || !this.form.title[langCode].trim())) return false;
      }
      if (this.form.campaignCategory && typeof this.form.campaignCategory === 'object') {
        if (this.form.campaignCategory.en && this.form.campaignCategory.en.trim() && (!this.form.campaignCategory[langCode] || !this.form.campaignCategory[langCode].trim())) return false;
      }
      if (this.form.description && typeof this.form.description === 'object') {
        if (this.form.description.en && this.form.description.en.trim() && (!this.form.description[langCode] || !this.form.description[langCode].trim())) return false;
      }
      if (!this.isStartedCampaignLocked && this.showUnitField && this.form.goals && this.form.goals.unit && typeof this.form.goals.unit === 'object') {
        if (this.form.goals.unit.en && this.form.goals.unit.en.trim() && (!this.form.goals.unit[langCode] || !this.form.goals.unit[langCode].trim())) return false;
      }
      if (!this.isStartedCampaignLocked && this.form.inputType === 'multiple_selection' && this.form.checklistItems && Array.isArray(this.form.checklistItems)) {
        for (const item of this.form.checklistItems) {
          if (item.en && item.en.trim() && (!item[langCode] || !item[langCode].trim())) return false;
        }
      }
      if (!this.isStartedCampaignLocked && this.form.inputType === 'quiz' && this.form.quizQuestions && Array.isArray(this.form.quizQuestions)) {
        for (const q of this.form.quizQuestions) {
          if (q.question && q.question.en && q.question.en.trim() && (!q.question[langCode] || !q.question[langCode].trim())) return false;
          if (q.options && q.options.en && Array.isArray(q.options.en)) {
            const langOpts = q.options[langCode];
            for (let i = 0; i < q.options.en.length; i++) {
              if (q.options.en[i] && q.options.en[i].trim() && (!langOpts || !langOpts[i] || !langOpts[i].trim())) return false;
            }
          }
        }
      }
      return true;
    },
    getIncompleteTranslationLanguages() {
      return this.companyLanguages
        .filter(lang => lang.code !== 'en' && !this.isLanguageComplete(lang.code))
        .map(lang => lang.code);
    },
    copyFieldFromEnglish(fieldName) {
      const lang = this.activeLanguageIndex;
      if (fieldName === 'unit' && this.isStartedCampaignLocked) {
        return;
      }
      if (fieldName === 'campaignCategory') {
        this.$set(this.form.campaignCategory, lang, this.form.campaignCategory.en || '');
      } else if (fieldName === 'title') {
        this.$set(this.form.title, lang, this.form.title.en || '');
      } else if (fieldName === 'description') {
        this.$set(this.form.description, lang, this.form.description.en || '');
      } else if (fieldName === 'unit') {
        this.$set(this.form.goals.unit, lang, this.form.goals.unit.en || '');
      }
    },
    copyChecklistItemFromEnglish(index) {
      if (this.isStartedCampaignLocked) return;
      const lang = this.activeLanguageIndex;
      if (this.form.checklistItems[index]) {
        this.$set(this.form.checklistItems[index], lang, this.form.checklistItems[index].en || '');
      }
    },
    copyQuizQuestionFromEnglish(index) {
      if (this.isStartedCampaignLocked) return;
      const lang = this.activeLanguageIndex;
      const question = this.form.quizQuestions[index];
      if (question && question.question) {
        this.$set(question.question, lang, question.question.en || '');
      }
    },
    copyQuizOptionFromEnglish(questionIndex, optIndex) {
      if (this.isStartedCampaignLocked) return;
      const lang = this.activeLanguageIndex;
      const question = this.form.quizQuestions[questionIndex];
      if (question && question.options && question.options.en) {
        if (!question.options[lang]) {
          this.$set(question.options, lang, [...question.options.en]);
        } else {
          this.$set(question.options[lang], optIndex, question.options.en[optIndex] || '');
        }
      }
    },
    copyAllFromEnglish() {
      const lang = this.activeLanguageIndex;
      if (lang === 'en') return;
      if (this.form.campaignCategory.en && !this.form.campaignCategory[lang]) {
        this.$set(this.form.campaignCategory, lang, this.form.campaignCategory.en);
      }
      if (this.form.title.en && !this.form.title[lang]) {
        this.$set(this.form.title, lang, this.form.title.en);
      }
      if (this.form.description.en && !this.form.description[lang]) {
        this.$set(this.form.description, lang, this.form.description.en);
      }
      if (!this.isStartedCampaignLocked && this.form.goals && this.form.goals.unit && this.form.goals.unit.en && !this.form.goals.unit[lang]) {
        this.$set(this.form.goals.unit, lang, this.form.goals.unit.en);
      }
      if (!this.isStartedCampaignLocked && this.form.checklistItems && Array.isArray(this.form.checklistItems)) {
        for (const item of this.form.checklistItems) {
          if (item.en && !item[lang]) {
            this.$set(item, lang, item.en);
          }
        }
      }
      if (!this.isStartedCampaignLocked && this.form.quizQuestions && Array.isArray(this.form.quizQuestions)) {
        for (const q of this.form.quizQuestions) {
          if (q.question && q.question.en && !q.question[lang]) {
            this.$set(q.question, lang, q.question.en);
          }
          if (q.options && q.options.en) {
            if (!q.options[lang]) {
              this.$set(q.options, lang, [...q.options.en]);
            } else {
              for (let i = 0; i < q.options.en.length; i++) {
                if (q.options.en[i] && !q.options[lang][i]) {
                  this.$set(q.options[lang], i, q.options.en[i]);
                }
              }
            }
          }
        }
      }
      this.validation.translationFields = false;
      this.translationValidationMessage = '';
    },
    initializeMultilingualFields() {
      // Ensure all translatable fields have entries for each language
      for (const lang of this.companyLanguages) {
        const code = lang.code;
        
        // Initialize title
        if (this.form.title && typeof this.form.title === 'object') {
          if (!this.form.title[code]) {
            this.$set(this.form.title, code, '');
          }
        }
        
        // Initialize description
        if (this.form.description && typeof this.form.description === 'object') {
          if (!this.form.description[code]) {
            this.$set(this.form.description, code, '');
          }
        }
        
        // Initialize goals.unit
        if (this.form.goals && this.form.goals.unit && typeof this.form.goals.unit === 'object') {
          if (!this.form.goals.unit[code]) {
            this.$set(this.form.goals.unit, code, '');
          }
        }
        
        // Initialize checklistItems
        if (this.form.checklistItems && Array.isArray(this.form.checklistItems)) {
          for (const item of this.form.checklistItems) {
            if (typeof item === 'object' && !item[code]) {
              this.$set(item, code, '');
            }
          }
        }
        
        // Initialize quizQuestions
        if (this.form.quizQuestions && Array.isArray(this.form.quizQuestions)) {
          for (const question of this.form.quizQuestions) {
            // Initialize question text
            if (question.question && typeof question.question === 'object' && !question.question[code]) {
              this.$set(question.question, code, '');
            }
            // Initialize options
            if (question.options && typeof question.options === 'object' && !Array.isArray(question.options)) {
              if (!question.options[code]) {
                this.$set(question.options, code, ['', '', '', '']);
              }
            }
          }
        }
      }
    },
    convertToMultilingual(value, englishFallback) {
      // Convert old string format to new multilingual object format
      if (!value && !englishFallback) {
        return { en: '' };
      }
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        // Already in multilingual format
        return { en: '', ...value };
      }
      // Convert string to multilingual object
      // Use englishFallback if available (for backward compatibility fields like title_en)
      const enValue = englishFallback || (typeof value === 'string' ? value : '');
      const displayValue = typeof value === 'string' ? value : '';
      return { 
        en: enValue, 
        th: displayValue !== enValue ? displayValue : '' 
      };
    },
    convertChecklistToMultilingual(items) {
      if (!items || !Array.isArray(items)) {
        return [];
      }
      return items.map(item => {
        if (typeof item === 'object' && item !== null) {
          // Already in multilingual format
          return { en: '', ...item };
        }
        // Convert string to multilingual object
        return { en: item || '' };
      });
    },
    convertQuizToMultilingual(questions) {
      if (!questions || !Array.isArray(questions)) {
        return [];
      }
      return questions.map(q => {
        // Convert question text
        let question;
        if (typeof q.question === 'object' && q.question !== null && !Array.isArray(q.question)) {
          question = { en: '', ...q.question };
        } else {
          question = { en: q.question_en || q.question || '' };
        }
        
        // Convert options
        let options;
        if (q.options && typeof q.options === 'object' && !Array.isArray(q.options)) {
          // Already in multilingual format { en: [...], th: [...] }
          options = q.options;
        } else if (Array.isArray(q.options)) {
          // Old format: array of strings
          options = { en: q.options.map(opt => opt || '') };
        } else {
          options = { en: ['', '', '', ''] };
        }
        
        return {
          ...q,
          question,
          options,
          correctAnswer: q.correctAnswer || 0
        };
      });
    },
    getQuizOptionsForLanguage(question) {
      // Get options array for current language, falling back to English
      if (!question.options) return ['', '', '', ''];
      const langOptions = question.options[this.activeLanguageIndex];
      if (langOptions && Array.isArray(langOptions)) {
        return langOptions;
      }
      // Fallback to English options
      return question.options.en || ['', '', '', ''];
    },
    initForm() {
      // Set flag to prevent applyTypeDefaults from overwriting saved values during edit load
      this.isInitializingForm = true;
      
      if (this.campaign) {
        // Edit mode - populate form with campaign data
        // timing.startDate is date-only (yyyy-MM-dd) — when delivery begins.
        let startDateStr = null;
        if (this.campaign.timing && this.campaign.timing.startDate) {
          const dateObj = this.campaign.timing.startDate.toDate
            ? this.campaign.timing.startDate.toDate() // Firestore Timestamp
            : new Date(this.campaign.timing.startDate); // String or Date

          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          startDateStr = `${year}-${month}-${day}`;
        }

        // launchAt is a separate datetime (yyyy-MM-dd HH:mm:ss) — when sign-ups open.
        let launchAtStr = null;
        let launchAtObj = null;
        if (this.campaign.launchAt) {
          launchAtObj = this.campaign.launchAt.toDate
            ? this.campaign.launchAt.toDate()
            : new Date(this.campaign.launchAt);
          launchAtStr = this.formatLocalDateTimeString(launchAtObj);
        }

        // Derive launchMode: 'scheduled' if the campaign was deliberately scheduled
        // (stored status === 'scheduled') or has a future launchAt; otherwise 'now'.
        const storedStatus = this.campaign.status;
        const isFutureLaunch = launchAtObj && launchAtObj.getTime() > Date.now();
        this.launchMode = (storedStatus === 'scheduled' || isFutureLaunch) ? 'scheduled' : 'now';

        // Convert old string format to new multilingual format for backward compatibility
        const campaignCategory = this.convertToMultilingual(this.campaign.campaignCategory, this.campaign.campaignCategory_en);
        const title = this.convertToMultilingual(this.campaign.title, this.campaign.title_en);
        const description = this.convertToMultilingual(this.campaign.description, this.campaign.description_en);
        const unit = this.convertToMultilingual(
          this.campaign.goals && this.campaign.goals.unit,
          this.campaign.goals && this.campaign.goals.unit_en
        );
        const checklistItems = this.convertChecklistToMultilingual(this.campaign.checklistItems);
        const quizQuestions = this.convertQuizToMultilingual(this.campaign.quizQuestions);

        this.form = {
          ...this.campaign,
          campaignCategory: campaignCategory,
          title: title,
          description: description,
          launchAt: launchAtStr,
          timing: {
            frequency: (this.campaign.timing && this.campaign.timing.frequency) || "daily",
            startDate: startDateStr,
            occurrences: (this.campaign.timing && this.campaign.timing.occurrences) || 30,
            dayOfWeek: (this.campaign.timing && this.campaign.timing.dayOfWeek) || 1,
          },
          goals: {
            dailyEnabled: true,  // Always required
            dailyTarget: (this.campaign.goals && this.campaign.goals.dailyTarget) || 10,
            individualEnabled: true,  // Always required
            individualTarget: (this.campaign.goals && this.campaign.goals.individualTarget) || 240,
            groupEnabled: (this.campaign.goals && this.campaign.goals.groupEnabled) || false,  // Optional
            groupTarget: (this.campaign.goals && this.campaign.goals.groupTarget) || 1000,
            unit: unit,
          },
          reward: {
            type: (this.campaign.reward && this.campaign.reward.type) || "charged",
            coins: (this.campaign.reward && this.campaign.reward.coins) || 1,
            chargedCoins: (this.campaign.reward && this.campaign.reward.chargedCoins) || 1,
            prizePoolCoins: (this.campaign.reward && this.campaign.reward.prizePoolCoins) || 1,
            multipleSelectionRule: (this.campaign.reward && this.campaign.reward.multipleSelectionRule) || "per_item",
          },
          entryCost: this.campaign.entryCost !== undefined ? this.campaign.entryCost : 5,
          entryLimit: this.campaign.entryLimit || 100,
          entryLimitEnabled: this.campaign.entryLimitEnabled || false,
          commentPermission: this.campaign.commentPermission !== undefined ? this.campaign.commentPermission : 1,
          allowDecimals: this.campaign.allowDecimals || false,
          trackingMode: this.campaign.trackingMode || "incremental",
          yesNoSuccessAnswer: this.campaign.yesNoSuccessAnswer || "yes",
          yesNoOptions: this.campaign.yesNoOptions || (this.campaign.yesNoSuccessAnswer === "no" 
            ? { yes: { en: "Yes", th: "ใช่" }, no: { en: "No, I didn't!", th: "ไม่ ยังไม่ได้ทำ!" } }
            : { yes: { en: "Yes, I did!", th: "ใช่ ทำแล้ว!" }, no: { en: "No", th: "ไม่" } }),
          quizQuestions: quizQuestions,
          checklistItems: checklistItems,
          theme: this.campaign.theme || { gradientKey: "purple", accentHex: "#7D5ABA" },
          iconKey: this.campaign.iconKey || "ic_star_24px",
        };
        
        // Initialize huddleTag from saved huddles (convert from stored format back to cascader format)
        if (this.campaign.huddles && this.campaign.huddles.length > 0) {
          // Check if "everyone" (key: 'all') is selected
          const hasEveryone = this.campaign.huddles.some(h => h.key === 'all');
          if (hasEveryone) {
            this.huddleTag = [["everyone"]];
          } else {
            // Convert huddles array [{key, value, team/house}] to cascader format [[key], [key]]
            this.huddleTag = this.campaign.huddles.map(h => [h.key]);
          }
        } else {
          this.huddleTag = [["everyone"]];
        }
        
      } else {
        // Create mode - reset to defaults
        this.launchMode = 'now';
        const defaultFrequency = "daily";
        this.form = {
          campaignCategory: { en: "" },
          description: { en: "" },
          title: { en: "" },
          iconKey: null,
          theme: { gradientKey: "purple", accentHex: "#7D5ABA" },
          inputType: "count",
          inputSubType: null,
          yesNoSuccessAnswer: "yes",
          yesNoOptions: { 
            yes: { en: "Yes, I did!", th: "ใช่ ทำแล้ว!" },
            no: { en: "No", th: "ไม่" }
          },
          allowDecimals: false,
          trackingMode: "incremental",
          launchAt: null,
          timing: {
            frequency: defaultFrequency,
            startDate: null,
            occurrences: DEFAULT_OCCURRENCES[defaultFrequency],
            dayOfWeek: 1,
          },
          goals: {
            dailyEnabled: true,       // Always required
            dailyTarget: 10,
            individualEnabled: true,  // Always required
            individualTarget: 240,    // Auto-calculated: 10 × 30 × 0.8
            groupEnabled: false,      // Optional
            groupTarget: 1000,
            unit: { en: "items" },
          },
          reward: {
            type: "charged",
            coins: 1,
            chargedCoins: 1,
            prizePoolCoins: 1,
            multipleSelectionRule: "per_item",
          },
          entryCost: 5,
          entryLimit: 100,
          entryLimitEnabled: false,
          commentPermission: 1,
          quizQuestions: [],
          checklistItems: [],
        };
        
        // Reset huddleTag to default for create mode
        this.huddleTag = [["everyone"]];
        
      }
      this.resetValidation();
      
      // Clear the initialization flag after Vue processes the reactive updates
      this.$nextTick(() => {
        this.isInitializingForm = false;
      });
    },
    resetValidation() {
      this.translationValidationMessage = '';
      this.validation = {
        campaignCategory: false,
        title: false,
        startDate: false,
        launchAt: false,
        launchAtInPast: false,
        occurrences: false,
        iconKey: false,
        translationFields: false,
      };
    },
    setLaunchMode(mode) {
      if (this.isStartedCampaignLocked) return;
      if (mode !== 'now' && mode !== 'scheduled') return;
      this.launchMode = mode;
      this.validation.launchAt = false;
      this.validation.launchAtInPast = false;
      if (mode === 'now') {
        // Clear any pending scheduled launch — handleSubmit stamps "now" on save.
        this.form.launchAt = null;
      }
    },
    formatLocalDateTimeString(date) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    validateForm() {
      this.resetValidation();
      let isValid = true;

      // Validate English category (required for all campaigns)
      const englishCategory = this.form.campaignCategory && typeof this.form.campaignCategory === 'object' 
        ? this.form.campaignCategory.en 
        : this.form.campaignCategory;
      if (!englishCategory || englishCategory.trim() === "") {
        this.validation.campaignCategory = true;
        isValid = false;
      }

      // Validate English title (required for all campaigns)
      const englishTitle = this.form.title && typeof this.form.title === 'object' 
        ? this.form.title.en 
        : this.form.title;
      if (!englishTitle || englishTitle.trim() === "") {
        this.validation.title = true;
        isValid = false;
        // Switch to English tab to show the validation error
        if (this.activeLanguageIndex !== 'en') {
          this.activeLanguageIndex = 'en';
        }
      }

      // Start Date (when the campaign begins delivering) is always required.
      if (!this.form.timing.startDate) {
        this.validation.startDate = true;
        isValid = false;
      }

      // Scheduled launch: the launchAt datetime must exist and be in the future.
      if (this.launchMode === 'scheduled') {
        if (!this.form.launchAt) {
          this.validation.launchAt = true;
          isValid = false;
        } else {
          const scheduled = new Date(this.form.launchAt);
          if (isNaN(scheduled.getTime()) || scheduled.getTime() <= Date.now() + 60 * 1000) {
            this.validation.launchAtInPast = true;
            isValid = false;
          }
        }
      }

      if (!this.form.timing.occurrences || this.form.timing.occurrences < 1) {
        this.validation.occurrences = true;
        isValid = false;
      }

      // Validate icon is selected
      if (!this.form.iconKey) {
        this.validation.iconKey = true;
        isValid = false;
      }

      // Validate translations for all non-English languages
      if (this.hasMultipleLanguages) {
        const incompleteLanguages = this.getIncompleteTranslationLanguages();
        if (incompleteLanguages.length > 0) {
          this.validation.translationFields = true;
          const langNames = incompleteLanguages.map(code => {
            const lang = this.companyLanguages.find(l => l.code === code);
            return lang ? lang.text : code.toUpperCase();
          }).join(', ');
          this.translationValidationMessage = `Translations incomplete for ${langNames}. Fill in the fields or use "Use English" to copy.`;
          if (this.isPrimaryLanguage) {
            this.activeLanguageIndex = incompleteLanguages[0];
          }
          isValid = false;
        }
      }

      return isValid;
    },
    // Working day calculation helpers
    isWorkingDay(date) {
      // Returns true if date is Monday (1) through Friday (5)
      const day = date.getDay();
      return day >= 1 && day <= 5;
    },
    isCompanyHoliday(date) {
      // Normalize the input date to midnight for comparison
      const checkDate = new Date(date);
      checkDate.setHours(0, 0, 0, 0);
      const checkTime = checkDate.getTime();
      
      // Check against company holidays
      for (const holiday of this.companyHolidays) {
        const holidayDate = new Date(holiday);
        holidayDate.setHours(0, 0, 0, 0);
        if (holidayDate.getTime() === checkTime) {
          return true;
        }
      }
      return false;
    },
    isValidCampaignDay(date) {
      // A valid campaign day is a working day (M-F) that is NOT a company holiday
      return this.isWorkingDay(date) && !this.isCompanyHoliday(date);
    },
    calculateWorkingDaysEndDate(startDate, targetWorkingDays) {
      // Calculate the end date by counting only valid campaign days (M-F, excluding holidays)
      let currentDate = new Date(startDate);
      let workingDaysCount = 0;
      
      // Start counting from the start date
      while (workingDaysCount < targetWorkingDays) {
        if (this.isValidCampaignDay(currentDate)) {
          workingDaysCount++;
        }
        if (workingDaysCount < targetWorkingDays) {
          currentDate.setDate(currentDate.getDate() + 1);
        }
      }
      
      return currentDate;
    },
    formatStartDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    formatEndDate() {
      if (!this.form.timing.startDate || !this.form.timing.occurrences) return "";
      
      const startDate = new Date(this.form.timing.startDate);
      let endDate;
      
      if (this.form.timing.frequency === 'daily') {
        // For daily frequency, calculate based on working days (M-F, excluding holidays)
        endDate = this.calculateWorkingDaysEndDate(startDate, this.form.timing.occurrences);
      } else {
        // For weekly frequency, start date is the first occurrence
        // So for N weeks, add (N-1) weeks to get the last occurrence date
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + ((this.form.timing.occurrences - 1) * 7));
      }
      
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return endDate.toLocaleDateString('en-US', options);
    },
    calculateEndDate() {
      if (!this.form.timing.startDate || !this.form.timing.occurrences) return null;

      const startDate = new Date(this.form.timing.startDate);

      if (this.form.timing.frequency === 'daily') {
        // For daily frequency, calculate based on working days (M-F, excluding holidays)
        return this.calculateWorkingDaysEndDate(startDate, this.form.timing.occurrences);
      } else {
        // For weekly frequency, start date is the first occurrence
        // So for N weeks, add (N-1) weeks to get the last occurrence date
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + ((this.form.timing.occurrences - 1) * 7));
        return endDate;
      }
    },
    calculateIndividualTarget(force = false) {
      // Calculate: Daily Goal × Campaign Length × 80%
      const dailyTarget = this.form.goals.dailyTarget || 10;
      const occurrences = this.form.timing.occurrences || 30;
      const recommended = Math.round(dailyTarget * occurrences * 0.8);

      // Store previous recommended value
      if (!this._lastRecommended) {
        this._lastRecommended = recommended;
      }

      // Only auto-update if:
      // 1. Force flag is true (initial load)
      // 2. Current value matches the previous recommendation (user hasn't manually changed it)
      if (force || this.form.goals.individualTarget === this._lastRecommended) {
        this.form.goals.individualTarget = recommended;
      }

      // Update the last recommended value
      this._lastRecommended = recommended;
    },
    handleSubmit() {
      if (this.isSubmitLocked) {
        return;
      }

      // Stamp an immediate launchAt when launching now, so the store records
      // the moment sign-ups opened. timing.startDate (delivery start) is left
      // alone — the user picks that separately in the duration section.
      if (this.launchMode === 'now') {
        this.form.launchAt = this.formatLocalDateTimeString(new Date());
      }

      if (!this.validateForm()) {
        return;
      }

      this.localSubmitLocked = true;

      // Calculate end date from occurrences
      const endDate = this.calculateEndDate();

      // Format end date with 23:59:59 (end of day) so campaign is active throughout the end date
      let endDateStr = null;
      if (endDate) {
        const year = endDate.getFullYear();
        const month = String(endDate.getMonth() + 1).padStart(2, '0');
        const day = String(endDate.getDate()).padStart(2, '0');
        endDateStr = `${year}-${month}-${day}T23:59:59`;
      }

      const formData = {
        ...this.form,
        launchAt: this.form.launchAt,
        timing: {
          ...this.form.timing,
          startDate: this.form.timing.startDate,
          endDate: endDateStr,
          occurrences: this.form.timing.occurrences,
        },
      };

      // Emit form data along with huddles (same pattern as Town Hall and University Sessions)
      this.$emit("submit", { form: formData, huddles: this.huddleTag });
    },
    handleClose() {
      this.localSubmitLocked = false;
      this.$emit("close");
    },
    getRewardDescription(type) {
      if (this.form.inputType === 'multiple_selection') {
        if (type === 'instant') {
          return this.form.reward.multipleSelectionRule === 'per_item'
            ? 'Earn coins immediately per completed item when daily goal is reached'
            : 'Earn coins immediately when daily goal is reached';
        } else if (type === 'charged') {
          return this.form.reward.multipleSelectionRule === 'per_item'
            ? 'Coins accumulate per completed item when daily goal is reached, paid out at campaign end'
            : 'Coins accumulate when daily goal is reached, paid out at campaign end';
        }
      }
      
      // Default descriptions
      if (type === 'instant') {
        return 'Participants earn coins immediately upon each action';
      } else if (type === 'charged') {
        return 'Coins accumulate per action, paid out at campaign completion';
      }
      return '';
    },
    addQuizQuestion() {
      if (!this.form.quizQuestions) {
        this.form.quizQuestions = [];
      }
      // Create multilingual question structure
      const question = { en: '' };
      const options = { en: ['', '', '', ''] };
      
      // Initialize for all company languages
      for (const lang of this.companyLanguages) {
        if (lang.code !== 'en') {
          question[lang.code] = '';
          options[lang.code] = ['', '', '', ''];
        }
      }
      
      this.form.quizQuestions.push({
        question,
        options,
        correctAnswer: 0
      });
    },
    removeQuizQuestion(index) {
      this.form.quizQuestions.splice(index, 1);
    },
    addChecklistItem() {
      if (!this.form.checklistItems) {
        this.form.checklistItems = [];
      }
      // Create multilingual checklist item
      const item = { en: '' };
      for (const lang of this.companyLanguages) {
        if (lang.code !== 'en') {
          item[lang.code] = '';
        }
      }
      this.form.checklistItems.push(item);
    },
    removeChecklistItem(index) {
      this.form.checklistItems.splice(index, 1);
    },
    isInverseGoal() {
      // These activity types have inverse goals (lower is better)
      const inverseTypes = ['auto_sync_screen'];
      return inverseTypes.includes(this.form.inputType);
    },
    getGoalUnitText() {
      // Return appropriate unit text for activity types without custom units
      const unitTexts = {
        quiz: 'correct',
        multiple_selection: 'items',
        yes_no: '✓',
      };
      return unitTexts[this.form.inputType] || '';
    },
    getDisplayUnitText() {
      // Get the unit text for display, handling multilingual format
      const unit = this.form.goals && this.form.goals.unit;
      if (!unit) return 'items';
      if (typeof unit === 'string') return unit;
      if (typeof unit === 'object') {
        // Get value for current language with fallback to English
        return unit[this.activeLanguageIndex] || unit.en || 'items';
      }
      return 'items';
    },
    applyTypeDefaults(newType, oldType) {
      // Apply smart defaults when campaign type changes
      const defaults = CAMPAIGN_TYPE_DEFAULTS[newType];
      if (!defaults) return;

      // Skip applying defaults during initial form load in edit mode
      // This prevents overwriting the saved reward type when loading an existing campaign
      if (this.isInitializingForm && this.campaign && this.campaign.id) {
        return;
      }

      // Only apply defaults if this is a type change (not initial load when editing)
      // or if coming from a different type category
      const isNewCampaign = !this.campaign || !this.campaign.id;
      const isSignificantChange = isNewCampaign || (oldType && oldType !== newType);

      if (isSignificantChange) {
        // Apply title default (only if English title is empty or was a previous auto-generated default)
        if (defaults.title) {
          const frequency = this.form.timing.frequency || 'daily';
          const newTitle = typeof defaults.title === 'object' ? defaults.title[frequency] : defaults.title;
          const allDefaultTitles = this.getAllDefaultTitles();
          const currentEnglishTitle = this.form.title && typeof this.form.title === 'object' ? this.form.title.en : '';
          const isPreviousDefault = allDefaultTitles.includes(currentEnglishTitle);
          if (!currentEnglishTitle || currentEnglishTitle.trim() === '' || isPreviousDefault) {
            // Set English title, preserve other language translations
            if (typeof this.form.title !== 'object') {
              this.form.title = { en: newTitle };
            } else {
              this.$set(this.form.title, 'en', newTitle);
            }
          }
        }

        // Apply unit (as multilingual object)
        if (typeof this.form.goals.unit !== 'object') {
          this.form.goals.unit = { en: defaults.unit };
        } else {
          this.$set(this.form.goals.unit, 'en', defaults.unit);
        }

        // Apply period target based on frequency
        const frequency = this.form.timing.frequency || 'daily';
        if (frequency === 'weekly' && defaults.weeklyTarget) {
          this.form.goals.dailyTarget = defaults.weeklyTarget;
        } else {
          this.form.goals.dailyTarget = defaults.dailyTarget;
        }

        // For Yes/No type, period target is always 1 (binary)
        if (newType === 'yes_no') {
          this.form.goals.dailyTarget = 1;
        }

        // Apply reward defaults
        this.form.reward.type = defaults.reward.type;
        this.form.reward.coins = defaults.reward.coins;
        this.form.reward.chargedCoins = defaults.reward.chargedCoins;
        this.form.reward.prizePoolCoins = defaults.reward.prizePoolCoins;
        if (defaults.reward.multipleSelectionRule) {
          this.form.reward.multipleSelectionRule = defaults.reward.multipleSelectionRule;
        }

        // Recalculate individual target based on new period target
        this.calculateIndividualTarget(true);
      }
    },
    applyFrequencyDefaults(newFrequency, oldFrequency) {
      // Apply smart defaults when frequency changes between daily and weekly
      if (!oldFrequency || newFrequency === oldFrequency) return;

      const defaults = CAMPAIGN_TYPE_DEFAULTS[this.form.inputType];
      
      // Update occurrences if still at the old frequency's default
      const oldDefaultOccurrences = DEFAULT_OCCURRENCES[oldFrequency];
      const newDefaultOccurrences = DEFAULT_OCCURRENCES[newFrequency];
      if (this.form.timing.occurrences === oldDefaultOccurrences) {
        this.form.timing.occurrences = newDefaultOccurrences;
      }

      // Update English title if it matches a known default title
      const currentEnglishTitle = this.form.title && typeof this.form.title === 'object' ? this.form.title.en : '';
      if (defaults && defaults.title && typeof defaults.title === 'object') {
        const oldTitle = defaults.title[oldFrequency];
        const newTitle = defaults.title[newFrequency];
        if (currentEnglishTitle === oldTitle) {
          this.$set(this.form.title, 'en', newTitle);
        } else {
          // Check if title matches any other type's old frequency default
          const allDefaultTitles = this.getAllDefaultTitles();
          if (allDefaultTitles.includes(currentEnglishTitle)) {
            // Find which type's title this is and update it
            for (const typeDefaults of Object.values(CAMPAIGN_TYPE_DEFAULTS)) {
              if (typeDefaults.title && typeof typeDefaults.title === 'object') {
                if (currentEnglishTitle === typeDefaults.title[oldFrequency]) {
                  this.$set(this.form.title, 'en', typeDefaults.title[newFrequency]);
                  break;
                }
              }
            }
          }
        }
      }

      // Update period target if type has frequency-specific targets
      if (defaults) {
        if (newFrequency === 'weekly' && defaults.weeklyTarget) {
          // Only update if current value matches the daily default
          if (this.form.goals.dailyTarget === defaults.dailyTarget) {
            this.form.goals.dailyTarget = defaults.weeklyTarget;
          }
        } else if (newFrequency === 'daily' && defaults.weeklyTarget) {
          // Only update if current value matches the weekly default
          if (this.form.goals.dailyTarget === defaults.weeklyTarget) {
            this.form.goals.dailyTarget = defaults.dailyTarget;
          }
        }
      }

      // Recalculate individual target
      this.calculateIndividualTarget(true);
    },
    handleYesNoSuccessChange(newValue) {
      // Update display options based on which answer is correct
      // When "No" is the correct answer, we show "No, I didn't!" to make it feel more natural
      if (newValue === 'no') {
        this.form.yesNoOptions = {
          yes: { en: "Yes", th: "ใช่" },
          no: { en: "No, I didn't!", th: "ไม่ ยังไม่ได้ทำ!" }
        };
      } else {
        this.form.yesNoOptions = {
          yes: { en: "Yes, I did!", th: "ใช่ ทำแล้ว!" },
          no: { en: "No", th: "ไม่" }
        };
      }
    },
    getAllDefaultTitles() {
      // Get all default titles (both daily and weekly variants)
      const titles = [];
      for (const defaults of Object.values(CAMPAIGN_TYPE_DEFAULTS)) {
        if (defaults.title) {
          if (typeof defaults.title === 'object') {
            if (defaults.title.daily) titles.push(defaults.title.daily);
            if (defaults.title.weekly) titles.push(defaults.title.weekly);
          } else {
            titles.push(defaults.title);
          }
        }
      }
      return titles;
    },
    getAudienceHint() {
      // huddleTag is array of arrays for cascader (e.g., [["everyone"]] or [["-Lxxx"], ["-Lyyy"]])
      if (!this.huddleTag || this.huddleTag.length === 0) {
        return 'Select an audience for this campaign';
      }

      const hasProgramOnly = this.huddleTag.some(item => item && item[0] === 'program_only');
      if (hasProgramOnly) {
        return 'Campaign hidden from University — surfaces only to Learning Program enrolees';
      }

      // Check if "everyone" is selected
      const hasEveryone = this.huddleTag.some(item => item && item[0] === 'everyone');
      if (hasEveryone) {
        return 'Campaign visible to everyone';
      }

      // Count teams and houses from huddleTagData
      let teamCount = 0;
      let houseCount = 0;

      for (const item of this.huddleTag) {
        if (!item || !item[0]) continue;
        const value = item[0];
        const huddle = this.huddleTagData.find(h => h.value === value);
        if (huddle) {
          if (huddle.type === 'team') {
            teamCount++;
          } else if (huddle.type === 'houses') {
            houseCount++;
          }
        }
      }

      const parts = [];
      if (teamCount > 0) {
        parts.push(`${teamCount} team${teamCount > 1 ? 's' : ''}`);
      }
      if (houseCount > 0) {
        parts.push(`${houseCount} group${houseCount > 1 ? 's' : ''}`);
      }

      if (parts.length === 0) {
        return 'Select an audience for this campaign';
      }

      return `Campaign visible to ${parts.join(' and ')}`;
    },
  },
  async created() {
    // Ensure user data is loaded before checking languages
    // (checkEngOnly depends on main.allUser to detect available languages)
    const mainState = this.$store.state.main;
    const allUser = mainState && mainState.allUser;
    if (!allUser || Object.keys(allUser).length === 0) {
      await this.$store.dispatch("main/getuser", false);
    }
    // Load available languages for translation support
    this.$store.dispatch("reward/checkEngOnly");
    // Load huddle/team data for audience selection (same as university sessions)
    this.$store.dispatch("happilyvillageUniversity/getHouseAndTeam");
  },
  mounted() {
    // Calculate initial individual target (force update)
    this.calculateIndividualTarget(true);

    // Initialize form if opened in edit mode
    if (this.campaign && this.visible) {
      this.initForm();
    }
    
  },
};
</script>

<style scoped>
.program-only-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 12px;
  background: #f2ecfb;
  border: 1px solid rgba(108, 48, 204, 0.20);
  border-radius: 8px;
  font-size: 12px;
  color: #522698;
  line-height: 1.5;
}
.program-only-hint i {
  color: #6c30cc;
  font-size: 14px;
  margin-top: 1px;
}
.program-only-hint span {
  flex: 1;
}

.grid-2-sesstion {
  display: grid;
  grid-template-columns: 440px 1fr;
  gap: 0;
  height: 85vh;
  max-height: 85vh;
}

.grid-left {
  background: linear-gradient(180deg, #F3EBFF 0%, #F8F9FA 100%);
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #E5E7EB;
  height: 100%;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.grid-right {
  padding: 28px 36px 40px 36px;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  height: 100%;
  max-height: 85vh;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.header {
  font-size: 11px;
  font-weight: 700;
  padding: 24px 24px 20px 24px;
  margin-bottom: 24px;
  color: #6C30CC;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: white;
  border-bottom: 1px solid #E5E7EB;
}

.header img {
  filter: brightness(0) saturate(100%) invert(26%) sepia(83%) saturate(2893%) hue-rotate(265deg) brightness(90%) contrast(98%);
}

.header-text {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, 'Kanit', "Helvetica Neue", Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 1px;
}

.body {
  padding: 0 24px 40px 24px;
}

/* Language Tabs */
.language-tabs-container {
  margin: -28px -36px 20px -36px;
  padding: 0 36px;
  border-bottom: 1px solid #E5E7EB;
  background: #FAFBFC;
}

.language-tabs-header {
  padding: 12px 0 0 0;
}

.language-tabs-label {
  font-size: 11px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.language-menu {
  background: transparent !important;
  border-bottom: none !important;
}

.language-menu-item {
  font-size: 14px;
  font-weight: 600;
  color: #6B7280;
  padding: 12px 16px !important;
  margin-right: 8px;
  position: relative;
}

.language-menu >>> .el-menu-item {
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.language-menu >>> .el-menu-item.is-active {
  color: #6C30CC !important;
  border-bottom-color: #6C30CC !important;
  background: transparent !important;
}

.language-menu >>> .el-menu-item:hover {
  background: rgba(108, 48, 204, 0.05) !important;
}

.translation-incomplete-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #F59E0B;
  border-radius: 50%;
  margin-left: 6px;
  vertical-align: middle;
}

/* Translation Mode Styles */
.translation-mode-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #F9F5FF;
  border: 1px solid #E9D5FF;
  border-radius: 10px;
  padding: 14px 20px;
  margin-bottom: 20px;
}

.translation-mode-info {
  min-width: 0;
}

.translation-mode-title {
  font-size: 14px;
  font-weight: 700;
  color: #4C1D95;
  line-height: 1.3;
}

.translation-mode-hint {
  font-size: 12px;
  color: #7C3AED;
  line-height: 1.3;
  margin-top: 1px;
  opacity: 0.8;
}

.translation-copy-all-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: #6C30CC;
  border: 1px solid #D8B4FE;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.translation-copy-all-btn:hover {
  background: #6C30CC;
  color: white;
  border-color: #6C30CC;
}

.translation-copy-all-btn svg {
  flex-shrink: 0;
}

/* Translation Validation Banner */
.translation-validation-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #FFFBEB;
  border: 1px solid #FCD34D;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.translation-validation-icon {
  color: #D97706;
  flex-shrink: 0;
}

.translation-validation-text {
  flex: 1;
  font-size: 13px;
  color: #92400E;
  font-weight: 500;
  line-height: 1.4;
}

.translation-validation-dismiss {
  background: none;
  border: none;
  color: #D97706;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.15s ease;
}

.translation-validation-dismiss:hover {
  opacity: 1;
}

.campaign-lock-banner {
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.campaign-lock-banner-title {
  font-size: 13px;
  font-weight: 700;
  color: #1D4ED8;
  margin-bottom: 4px;
}

.campaign-lock-banner-text {
  font-size: 13px;
  line-height: 1.45;
  color: #1E3A8A;
}

/* Translation reference rows */
.translation-reference {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 6px 10px;
  background: #F9FAFB;
  border-left: 3px solid #E9D5FF;
  border-radius: 0 6px 6px 0;
  font-size: 13px;
  color: #6B7280;
  line-height: 1.4;
}

.translation-reference-inline {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  font-size: 12px;
  color: #9CA3AF;
}

.reference-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Use English buttons */
.use-english-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid #E9D5FF;
  color: #6C30CC;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s ease;
  margin-left: auto;
}

.use-english-btn:hover {
  background: #6C30CC;
  color: white;
  border-color: #6C30CC;
}

.use-english-btn--inline {
  border: none;
  padding: 0 4px;
}

.use-english-btn--inline:hover {
  background: none;
  color: #5A28A8;
  text-decoration: underline;
}

.translation-empty-state {
  padding: 24px;
  text-align: center;
  color: #9CA3AF;
  background: #F9FAFB;
  border-radius: 8px;
  font-size: 14px;
}

.checklist-item-input-wrapper,
.quiz-option-input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #F3F4F6;
}

.form-section:last-of-type {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

/* Campaign Overview Section */
.campaign-overview-section {
  background: linear-gradient(135deg, #FAFBFC 0%, #F3F4F6 100%);
  margin: -28px -36px 24px -36px;
  padding: 24px 36px 28px 36px;
  border-bottom: 2px solid #E5E7EB;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.3px;
}

.overview-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.overview-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.overview-field.full-width {
  width: 100%;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.description-input >>> .el-textarea__inner {
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  font-size: 14px;
  padding: 12px 15px;
  transition: all 0.2s ease;
  line-height: 1.6;
  background: white;
}

.description-input >>> .el-textarea__inner:focus {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}

.description-input >>> .el-textarea__inner::placeholder {
  color: #9CA3AF;
}

.title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #111827;
  letter-spacing: -0.2px;
}

.sub-title {
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.validate-input {
  border-color: #f56c6c !important;
}

.validate-worming {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 6px;
  font-weight: 500;
}

.validate-worming-inline {
  color: #f56c6c;
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
}

.validate-input-box {
  border: 2px solid #f56c6c !important;
  border-radius: 14px;
  padding: 2px;
}

.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Access & Participation Section */
.access-section {
  background: linear-gradient(135deg, #FAFBFC 0%, #F8F9FA 100%);
  border-radius: 14px;
  padding: 20px 20px 24px !important;
  border: 1px solid #E5E7EB;
}

.access-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  width: 100%;
}

.access-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.access-field .sub-title {
  margin-bottom: 6px;
  font-size: 10px;
}

.access-field .field-hint {
  margin-top: 4px;
  font-size: 10px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Goal Section */
.goal-unit-row {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  border: 2px solid #E9D5FF;
  border-radius: 12px;
}

.goal-unit-label {
  font-size: 12px;
  font-weight: 700;
  color: #6C30CC;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 8px;
}

.goal-unit-input {
  width: 100%;
  max-width: 200px;
}

.goal-unit-input >>> .el-input__inner {
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-weight: 600;
  color: #374151;
  background: white;
}

.goal-unit-input >>> .el-input__inner:focus {
  border-color: #6C30CC;
}

.goal-unit-hint {
  font-size: 11px;
  color: #6B7280;
  margin-top: 8px;
  font-style: italic;
}

.goal-type-hint {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  font-size: 13px;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 8px;
}

.goal-type-hint strong {
  font-weight: 700;
  color: #6C30CC;
}

.goal-unit-label-text {
  font-size: 12px;
  font-weight: 700;
  color: #6C30CC;
  white-space: nowrap;
  min-width: 50px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  padding: 6px 10px;
  border-radius: 6px;
}

.goal-row {
  display: grid;
  grid-template-columns: minmax(220px, auto) 1fr;
  align-items: start;
  gap: 16px;
  margin-bottom: 8px;
  padding: 16px 18px;
  background: #FAFBFC;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
  min-height: 56px;
}

.goal-row:hover {
  background: #F3F4F6;
}

.goal-row:has(.el-checkbox__input.is-checked) {
  background: white;
  border-color: #E9D5FF;
  box-shadow: 0 2px 8px rgba(108, 48, 204, 0.06);
}

.goal-row:last-child {
  margin-bottom: 0;
}

/* Required goal label (no checkbox) */
.goal-label-required {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  padding-top: 8px;
}

.goal-label-required > span:first-child {
  white-space: nowrap;
}

.required-badge {
  font-size: 10px;
  font-weight: 700;
  color: #6C30CC;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  padding: 3px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.optional-badge {
  font-size: 10px;
  font-weight: 600;
  color: #6B7280;
  background: #F3F4F6;
  padding: 3px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Yes/No Daily Goal Explanation */
.yes-no-explanation {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%) !important;
  border: 2px solid #A7F3D0 !important;
}

.yes-no-daily-info {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.yes-no-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}

.yes-no-text {
  flex: 1;
}

.yes-no-title {
  font-size: 14px;
  font-weight: 700;
  color: #065F46;
  margin-bottom: 2px;
}

.yes-no-description {
  font-size: 13px;
  color: #047857;
  line-height: 1.4;
}

/* Multiple Selection "All Items" Daily Goal Explanation */
.checklist-all-explanation {
  background: linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%) !important;
  border: 2px solid #C7D2FE !important;
}

.checklist-all-daily-info {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.checklist-all-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.checklist-all-text {
  flex: 1;
}

.checklist-all-title {
  font-size: 14px;
  font-weight: 700;
  color: #3730A3;
  margin-bottom: 2px;
}

.checklist-all-description {
  font-size: 13px;
  color: #4338CA;
  line-height: 1.4;
}

.goal-checkbox {
  flex: 1;
  min-width: 0;
}

.goal-checkbox >>> .el-checkbox__label {
  font-weight: 600;
  color: #6B7280;
  font-size: 14px;
  transition: color 0.2s ease;
}

.goal-checkbox >>> .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid #D1D5DB;
  transition: all 0.2s ease;
}

.goal-checkbox >>> .el-checkbox__inner::after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
}

.goal-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.goal-checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #111827;
  font-weight: 700;
}

.goal-input {
  width: 80px !important;
  flex-shrink: 0;
}

.goal-input >>> .el-input__inner {
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  height: 42px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #111827;
  background: white;
  transition: all 0.2s ease;
}

.goal-input >>> .el-input__inner:focus {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}

.goal-input-with-unit {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
}

.goal-unit-label {
  font-size: 12px;
  font-weight: 700;
  color: #6C30CC;
  white-space: nowrap;
  min-width: 50px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  padding: 6px 10px;
  border-radius: 6px;
}

.goal-input >>> .el-input__inner {
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  height: 40px;
  font-size: 15px;
  transition: all 0.2s ease;
}

.goal-input >>> .el-input__inner:focus {
  border-color: #6C30CC;
}

.goal-input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  justify-self: end;
}

.goal-hint {
  font-size: 11px;
  color: #9CA3AF;
  text-align: right;
  white-space: nowrap;
  padding-right: 2px;
}

/* Reward Section */
.reward-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reward-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: #FAFBFC;
  border: 2px solid transparent;
  border-radius: 12px;
  transition: all 0.2s ease;
  min-height: 72px;
  cursor: pointer;
}

.reward-option:hover {
  background: #F3F4F6;
}

.reward-option:has(.el-radio__input.is-checked) {
  background: white;
  border-color: #E9D5FF;
  box-shadow: 0 2px 8px rgba(108, 48, 204, 0.06);
}

.reward-option-content {
  flex: 1;
  min-width: 0;
}

.reward-label {
  font-weight: 700;
  color: #6B7280;
  font-size: 14px;
  transition: color 0.2s ease;
}

.reward-option:has(.el-radio__input.is-checked) .reward-label {
  color: #111827;
}

.reward-description {
  font-size: 12px;
  color: #9CA3AF;
  margin-top: 4px;
  line-height: 1.5;
  padding-left: 24px;
  transition: color 0.2s ease;
}

.reward-option:has(.el-radio__input.is-checked) .reward-description {
  color: #6B7280;
}

.reward-input {
  width: 90px !important;
  margin-left: 16px;
  flex-shrink: 0;
}

.reward-input >>> .el-input__inner {
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  height: 44px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #111827;
  background: white;
  transition: all 0.2s ease;
}

.reward-input >>> .el-input__inner:focus {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}

.reward-input-with-label {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.reward-coin-label {
  font-size: 12px;
  font-weight: 700;
  color: #F59E0B;
  white-space: nowrap;
  background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%);
  padding: 6px 10px;
  border-radius: 6px;
}

.reward-group >>> .el-radio__inner {
  width: 20px;
  height: 20px;
  border: 2px solid #D1D5DB;
  transition: all 0.2s ease;
}

.reward-group >>> .el-radio__inner::after {
  width: 8px;
  height: 8px;
}

.reward-group >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.reward-group >>> .el-radio__input.is-checked + .el-radio__label {
  color: #111827;
}

/* Form Actions */
.form-actions {
  margin-top: 16px;
  margin-bottom: 40px;
  padding-top: 12px;
  border-top: none;
}

.btn-add.bigger {
  width: 100%;
  height: 48px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #7D5ABA 0%, #6C30CC 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(108, 48, 204, 0.2);
  transition: all 0.2s ease;
}

.btn-add.bigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(108, 48, 204, 0.3);
}

/* CTA icon — sits to the left of the morphing label, mirrors the active launch card */
.cta-with-icon >>> span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.cta-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.18);
  color: #FFFFFF;
}

.cta-label {
  font-weight: 700;
}

/* Input Number Customization */
.goal-input >>> .el-input__inner,
.reward-input >>> .el-input__inner {
  text-align: center;
  font-weight: 700;
  color: #111827;
}

/* Date Display */
.date-display {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #6C30CC;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  padding: 8px 12px;
  border-radius: 10px;
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.2px;
  border: 1px solid #E9D5FF;
}

/* Field Hint */
.field-hint {
  margin-top: 10px;
  font-size: 12px;
  color: #9CA3AF;
  line-height: 1.4;
}

/* Launch section — promoted to gradient card so the launch decision and the CTA
   read together as the form's most decisive moment. */
.launch-section {
  background: linear-gradient(135deg, #FAFBFC 0%, #F6F1FE 100%);
  border: 1px solid #E9D5FF;
  border-radius: 14px;
  padding: 22px 22px 24px !important;
  margin-bottom: 16px;
  border-bottom: none;
}

.launch-section .title {
  margin-bottom: 14px;
}

/* Launch Mode — two-card radio */
.launch-mode-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.launch-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
  padding: 14px 16px;
  background: #FFFFFF;
  border: 1.5px solid #E5E7EB;
  border-radius: 14px;
  cursor: pointer;
  font: inherit;
  color: #6B7280;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.launch-card:hover:not(:disabled) {
  border-color: #C4B0E8;
  color: #4B5563;
  transform: translateY(-1px);
}

.launch-card:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.18);
}

.launch-card.active {
  background: linear-gradient(135deg, #FAF5FF 0%, #F3EBFF 100%);
  border-color: #6C30CC;
  color: #2D1A5E;
  box-shadow: 0 4px 14px rgba(108, 48, 204, 0.12);
}

.launch-card:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.launch-card-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #F3F4F6;
  color: #6B7280;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.launch-card.active .launch-card-icon {
  background: #6C30CC;
  color: #FFFFFF;
}

.launch-card-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.launch-card-title {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.1px;
  color: #111827;
}

.launch-card.active .launch-card-title {
  color: #2D1A5E;
}

.launch-card-sub {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: #6B7280;
}

.launch-card.active .launch-card-sub {
  color: #6C30CC;
}

.launch-schedule-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.launch-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  padding: 11px 14px;
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  line-height: 1.45;
  color: #4B2A99;
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  border: 1px solid #E9D5FF;
  border-radius: 10px;
  letter-spacing: 0.1px;
}

.launch-preview-icon {
  flex-shrink: 0;
  color: #6C30CC;
}

/* Soft validation pill — scoped to the Launch section's two messages */
.validate-warning--soft {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  background: #FEF3F2;
  border: 1px solid #FDA29B;
  border-radius: 8px;
}

.validate-worming.validate-warning--soft {
  color: #B42318;
}

.validate-warning--soft svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: #D92D20;
}

.launch-reveal-enter-active,
.launch-reveal-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.launch-reveal-enter,
.launch-reveal-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* Reward Condition for Multiple Selection */
.reward-condition {
  margin-bottom: 16px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  border: 1px solid #E2E8F0;
  border-radius: 12px;
}

.reward-condition-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reward-condition-group >>> .el-radio {
  margin-right: 0;
  padding: 10px 14px;
  background: white;
  border: 2px solid transparent;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}

.reward-condition-group >>> .el-radio:hover {
  background: #FAFBFC;
}

.reward-condition-group >>> .el-radio__input.is-checked ~ .el-radio__label {
  color: #6C30CC;
  font-weight: 700;
}

.reward-condition-group >>> .el-radio__input.is-checked {
  & + .el-radio__label {
    color: #6C30CC;
  }
}

.reward-condition-group >>> .el-radio.is-checked {
  background: white;
  border-color: #E9D5FF;
  box-shadow: 0 1px 4px rgba(108, 48, 204, 0.08);
}

.reward-condition-group >>> .el-radio__label {
  font-size: 13px;
  color: #6B7280;
  font-weight: 600;
  padding-left: 10px;
}

.reward-condition-group >>> .el-radio__inner {
  width: 18px;
  height: 18px;
  border: 2px solid #D1D5DB;
}

.reward-condition-group >>> .el-radio__inner::after {
  width: 6px;
  height: 6px;
}

.reward-condition-group >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.reward-condition-group >>> .el-radio__input.is-checked + .el-radio__label {
  color: #6C30CC;
}

/* Quiz Questions Section */
.quiz-questions-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 14px;
}

.quiz-question-item {
  padding: 16px;
  background: white;
  border: 2px solid #E5E7EB;
  border-radius: 14px;
  transition: all 0.2s ease;
}

.quiz-question-item:hover {
  border-color: #D1D5DB;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.quiz-question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.quiz-question-number {
  font-size: 12px;
  font-weight: 700;
  color: #6C30CC;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.quiz-question-input {
  margin-bottom: 14px;
}

.quiz-question-input >>> .el-input__inner {
  font-weight: 600;
  color: #111827;
  font-size: 14px;
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  padding: 12px 15px;
  height: auto;
}

.quiz-question-input >>> .el-input__inner:focus {
  border-color: #6C30CC;
}

.quiz-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quiz-option-row {
  display: flex;
  align-items: center;
}

.quiz-option-radio {
  width: 80%;
}

.quiz-option-radio >>> .el-radio__label {
  width: 100%;
  padding-left: 10px;
}

.quiz-option-radio >>> .el-input {
  width: 100%;
}

.quiz-option-radio >>> .el-input__inner {
  background: #F9FAFB;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.quiz-option-radio >>> .el-input__inner:focus {
  border-color: #6C30CC;
  background: white;
}

.quiz-option-radio >>> .el-radio__input.is-checked + .el-radio__label {
  color: #6C30CC;
}

.quiz-option-radio >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.quiz-option-radio >>> .el-radio__input.is-checked ~ .el-radio__label .el-input__inner {
  border-color: #6C30CC;
  background: white;
}

.btn-add-question {
  width: 100%;
  border: 2px dashed #D1D5DB;
  background: white;
  color: #6B7280;
  font-weight: 700;
  padding: 14px;
  height: 50px;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.btn-add-question:hover {
  border-color: #6C30CC;
  color: #6C30CC;
  background: #F9F5FF;
  transform: translateY(-1px);
}

/* General Input Styling */
.form-section >>> .el-input__inner {
  border-radius: 10px;
  border: 2px solid #E5E7EB;
  font-size: 14px;
  padding: 10px 15px;
  height: auto;
  min-height: 40px;
  transition: all 0.2s ease;
  box-shadow: 0 0 0 0px transparent;
}

.form-section >>> .el-input__inner:focus {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
  outline: none;
}

.form-section >>> .el-input__inner::placeholder {
  color: #9CA3AF;
}

.form-section >>> .el-select .el-input__inner {
  cursor: pointer;
}

.form-section >>> .el-date-editor .el-input__inner {
  padding-left: 40px;
}

.form-section >>> .el-cascader .el-input__inner {
  cursor: pointer;
}

/* Select Dropdown Styling */
.form-section >>> .el-select-dropdown__item.selected {
  color: #6C30CC;
  font-weight: 600;
}

/* Dropdown Panel Positioning */
.form-section >>> .el-picker-panel,
.form-section >>> .el-select-dropdown,
.form-section >>> .el-cascader__dropdown {
  z-index: 3000 !important;
}

.form-section >>> .el-popper {
  z-index: 3000 !important;
}

/* Scrollbar Styling */
.rm-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.rm-scrollbar::-webkit-scrollbar-track {
  background: #F3F4F6;
}

.rm-scrollbar::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}

.rm-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

/* Dialog Override */
.remove-padding-modal >>> .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
}

.remove-padding-modal >>> .el-dialog__header {
  display: none;
}

.remove-padding-modal >>> .el-dialog__body {
  padding: 0;
  overflow: hidden;
  max-height: 85vh;
  height: 85vh;
}

/* Field Hint Improvement */
.field-hint {
  font-style: italic;
}

/* Checklist Items Section */
.checklist-items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.checklist-item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border: 2px solid #E5E7EB;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.checklist-item-row:hover {
  border-color: #D1D5DB;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.checklist-item-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3EBFF 0%, #E9D5FF 100%);
  color: #6C30CC;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.checklist-item-input {
  flex: 1;
}

.checklist-item-input >>> .el-input__inner {
  border: none;
  background: transparent;
  font-weight: 600;
  color: #111827;
  font-size: 14px;
  padding: 0;
  height: auto;
}

.checklist-item-input >>> .el-input__inner:focus {
  border: none;
  box-shadow: none;
}

/* Success Answer Radio Group */
.success-answer-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.success-answer-group >>> .el-radio {
  margin-right: 0;
  padding: 12px 16px;
  background: white;
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.success-answer-group >>> .el-radio:hover {
  border-color: #D1D5DB;
  background: #F9FAFB;
}

.success-answer-group >>> .el-radio__input.is-checked ~ .el-radio__label {
  color: #6C30CC;
}

.success-answer-group >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.success-answer-group >>> .el-radio__label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

/* Entry Limit Checkbox */
.entry-limit-checkbox {
  margin-top: 10px !important;
}

.entry-limit-checkbox >>> .el-checkbox__label {
  font-size: 12px;
  font-weight: 500;
  color: #9CA3AF;
}

.entry-limit-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.entry-limit-checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #6C30CC;
}

/* Input Settings (Count Type) */
.input-setting-checkbox {
  display: block;
  padding: 12px 16px;
  background: #F9FAFB;
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.input-setting-checkbox:hover {
  border-color: #D1D5DB;
  background: white;
}

.input-setting-checkbox >>> .el-checkbox__label {
  width: 100%;
  white-space: normal;
}

.input-setting-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.checkbox-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: block;
  margin-bottom: 4px;
}

.checkbox-hint {
  font-size: 12px;
  color: #6B7280;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 4px;
}

.tracking-mode-group {
  padding: 14px 16px;
  background: #F9FAFB;
  border: 2px solid #E5E7EB;
  border-radius: 10px;
}

.tracking-mode-label {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tracking-mode-radios {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tracking-mode-radios >>> .el-radio {
  margin-right: 0;
  padding: 12px 14px;
  background: white;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
}

.tracking-mode-radios >>> .el-radio:hover {
  border-color: #D1D5DB;
  background: #FAFBFC;
}

.tracking-mode-radios >>> .el-radio__input.is-checked ~ .el-radio__label {
  color: #6C30CC;
}

.tracking-mode-radios >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #6C30CC;
  border-color: #6C30CC;
}

.tracking-mode-radios >>> .el-radio__input.is-checked ~ .el-radio__label .radio-label {
  color: #6C30CC;
}

.tracking-mode-radios >>> .el-radio__label {
  width: 100%;
  white-space: normal;
  padding-left: 10px;
}

.radio-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: block;
  margin-bottom: 4px;
}

.radio-hint {
  font-size: 12px;
  color: #6B7280;
  font-weight: 400;
  line-height: 1.5;
}

/* Audience Cascader - Same pattern as Town Hall and University Sessions */
.audience-cascader {
  width: 100%;
}

.audience-cascader >>> .el-input__inner {
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  font-size: 14px;
  min-height: 42px;
  padding: 8px 12px;
  transition: all 0.2s ease;
}

.audience-cascader >>> .el-input__inner:focus,
.audience-cascader >>> .el-input.is-focus .el-input__inner {
  border-color: #6C30CC;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}

.audience-cascader >>> .el-cascader__tags {
  padding-left: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  flex-wrap: wrap;
}

.audience-cascader >>> .el-tag {
  background: linear-gradient(135deg, #F9F5FF 0%, #F3EBFF 100%);
  border: 1px solid #E9D5FF;
  color: #6C30CC;
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  margin: 2px 6px 2px 0;
  padding: 4px 8px;
  height: auto;
  line-height: 1.4;
}

.audience-cascader >>> .el-tag__close {
  color: #6C30CC;
  background-color: transparent;
  margin-left: 4px;
}

.audience-cascader >>> .el-tag__close:hover {
  background-color: #E9D5FF;
  color: #6C30CC;
}

/* Cascader dropdown styling */
.audience-cascader >>> .el-cascader-menu {
  min-width: 200px;
}

.audience-cascader >>> .el-cascader-node.in-active-path,
.audience-cascader >>> .el-cascader-node.is-active {
  color: #6C30CC;
  font-weight: 600;
}

.audience-cascader >>> .el-cascader-node__label {
  padding: 0 10px 0 0;
}
</style>

<style lang="scss">
/* Non-scoped overrides for Campaign Form Access Section ONLY */
/* Using #campaignModal to scope styles to this component only */
#campaignModal .access-section {
  .access-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 14px !important;
    width: 100% !important;
  }
  
  .access-field {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    
    /* Force all selects, cascaders and inputs to fill width */
    .el-select,
    .el-cascader,
    .el-input,
    .el-input-number {
      width: 100% !important;
      display: block !important;
    }
    
    .el-input__inner {
      width: 100% !important;
    }
    
    /* Audience cascader tags - show as much text as possible */
    .audience-cascader {
      .el-cascader__tags {
        max-width: calc(100% - 30px) !important;
        flex-wrap: wrap !important;
      }
      
      .el-tag {
        max-width: none !important;
        flex-shrink: 1 !important;
        overflow: hidden !important;
        margin: 2px 4px 2px 0 !important;
        
        .el-cascader__tags-text {
          max-width: 140px !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          display: inline-block !important;
          white-space: nowrap !important;
        }
      }
      
      .el-tag__close {
        flex-shrink: 0 !important;
      }
    }
  }
}
</style>
